import React, { useRef, useEffect, useState, useContext, useReducer, useCallback } from 'react';

import * as XLSX from "xlsx"

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Box,
    Autocomplete,
    InputAdornment,
    Divider,
    Tooltip,
    Tabs,
    Tab,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    DialogActions,
    Button,
    TextField,
    Alert,
    AlertTitle,
    ButtonGroup,
    Link,
    IconButton,
    Paper,
    Popper,
    ClickAwayListener,
    Checkbox
} from "@mui/material"

import AddIcon from '@mui/icons-material/Add';
import NewCustomFieldForm from '../../Journeys/NewCustomFieldForm';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import useNotification from "../../Notification";

import CloseIcon from '@mui/icons-material/Close';
import ConfirmationDialogCaptcha from '../../Dialogs/ConfimationDialogCaptcha';

import '../../../index.css';
import api from '../../../api';
import { createBulkOpportunitiesForCampaign } from '../../../utils/createBulkOpportunities';
import { normalizeEmailRecipients } from '../../../utils/emailRecipients';

import MultiStep from './MultiStep';
import TimeSelector from './TimeSelector';
import DateTimeSelector from './DateTimeSelector';
import CampaignSummary from './CampaignSummary';
import VoiceCampaignConfig, { ShouldSendVoice, getVoiceCampaignDefaultState } from './VoiceCampaignConfig';

import ParameterFiller from '../Templates/ParameterFiller';

import SearchIcon from '@mui/icons-material/Search';

import { ScreenContext } from '..';
import { SendSMSContent, ShouldSendSms, getSmsDefaultState } from '../TabButtons/SendMessage/SendSMS';
import { getEmailDefaultState, ShouldSendEmail, SendEmailContent } from '../TabButtons/SendMessage/SendEmail';
import { colorOptionsMedium } from '../../Journeys/index';
import { SendScoutContent, getScoutDefaultState, ShouldSendScout, MessageFormat } from '../TabButtons/SendMessage/SendScout';
import defaultReducer, { lockedReducer } from '../../../utils/defaultReducer';

import { getSession } from "../../../auth";
import Loading from '../../Loading';
import { delayedChange } from '../../ManageCalls/FilterComponent';
import CircularProgress from '@mui/material/CircularProgress';
import LoadingButton from '@mui/lab/LoadingButton';
import { postEmailAttachments } from '../TabButtons/SendMessage/SendEmail';
import { getAttachments } from '../../Chat/MessagesArea/ChatWindow/MessageItem';

import useValidationError from "../../ErrorValidation"
import Modal from "../../Templates/360dialog/Modal"
import OpportunityMarkers from '../../Journeys/opportunity-markers';

let timeoutId

export const reportTriggers = {
    1: "24 horas após a execução",
    2: "2 dias após a execução",
    3: "3 dias após a execução",
    5: "5 dias após a execução",
    7: "1 semana após a execução"
}

export const months = {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro"
}

export const matchRegLen = value => {
    if (!value)
        return
    const matcher = value.match(/{{\d+}}/g)
    if (matcher)
        return matcher.length
    return 0
}

const splitCronList = (value) => String(value || '').split(',').filter(Boolean)

const getUncachedTemplates = async () => {
    await api.get(`api/enterprises/${getSession().profile.enterprise.id}/templates/?update=True`)
    return new Promise((resolve, reject) => {
        async function poll() {
            const response = await api.get(`api/enterprises/${getSession().profile.enterprise.id}/templates/`)
            const stillCaching = Object.values(response.data).some(value => value === "caching...")
            if (stillCaching)
                setTimeout(poll, 5000)
            else {
                const allTemplates = Object.values(response.data).map(entry => entry.waba_templates || []).flat()
                resolve(allTemplates)
            }
        }
        poll()
    })
}

const checkTemplateStatus = async (template, handleNumberChange, setStepLoading, selectedSender) => {
    const poll = async () => {
        const templates = await getUncachedTemplates()
        const newTemplate = templates.find((item) => item.id === template.id)
        if (!newTemplate) {
            setStepLoading(false)
            return
        }
        switch (newTemplate.status) {
            case "APPROVED":
                handleNumberChange(selectedSender)
                useNotification(
                    "Sucesso",
                    "Seu template foi aprovado e está pronto para uso.",
                    "success"
                )
                setStepLoading(false)
                return
            case "REJECTED":
                useNotification(
                    "Atenção!",
                    "Seu template não foi aprovado pelo WhatsApp, tente novamente.",
                    "danger"
                )
                setStepLoading(false)
                return
            default:
                setTimeout(poll, 5000)
        }
    }
    setStepLoading(true)
    poll()
}

export const ParamModal = ({selectedTemplate, parameters, mediaParameters, 
    checkParameters, allParamsFilled, updateParamModal, setUpdateButtons, handleParamGoBack, opportunityCustomFields = null }) => {
    return (
        <Dialog keepMounted
        open={true}
        onClose={() => { }}
        aria-labelledby="customized-dialog-title"
        fullWidth
        className={'PreviewTemplateDialog'}
        disableEnforceFocus
    >
        <DialogTitle id="customized-dialog-title">
            Preparação do template
        </DialogTitle>
        <Divider />
        <DialogContent>
            <Box>
                <ParameterFiller
                    mediaValues={selectedTemplate.components}
                    parameters={parameters}
                    submitParameters={mediaParameters}
                    setReady={checkParameters}
                    opportunityCustomFields={opportunityCustomFields}
                />
            </Box>
        </DialogContent>
        <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
            <Button onClick={handleParamGoBack} color="primary">
                Cancelar
            </Button>
            <Tooltip title={allParamsFilled ? allParamsFilled : ''} placement="top" describeChild={true}>
                <span>
                    <Button
                        onClick={() => { updateParamModal(false); setUpdateButtons(p => !p) }}
                        disabled={allParamsFilled ? true : false}
                        color="primary"
                    >
                        Salvar
                    </Button>
                </span>
            </Tooltip>
        </DialogActions>
    </Dialog>
    )
}

export const renderMessage = (selectedTemplate, mediaParameters) => {
    let parsedHeader, parsedBody, parsedFooter, attachments

    const header = selectedTemplate.components.find((component) => component.type === "HEADER")
    if (header) {
        let mediaUrl = mediaParameters["headerfile"] ?? mediaParameters["headerURL"] ?? header.example?.header_handle?.[0]
        if (mediaUrl instanceof File)
            mediaUrl = URL.createObjectURL(mediaUrl)
        switch (header.format) {
            case "IMAGE":
                parsedHeader = (
                    <img src={mediaUrl} style={{ maxWidth: "100%", marginBottom: ".5rem" }} />
                )
                break
            case "DOCUMENT":
                parsedHeader = (
                    <a href={mediaUrl} target="_blank" rel="noopener noreferrer" style={{ marginBottom: ".5rem" }}>
                        Documento
                    </a>
                )
                break
            case "VIDEO":
                parsedHeader = (
                    <video controls style={{ maxWidth: "100%", marginBottom: ".5rem" }}>
                        <source src={mediaUrl} />
                    </video>
                )
                break
            case "TEXT":
                parsedHeader = (
                    <div style={{ marginBottom: "1rem", fontWeight: "bold" }}>{header.text}</div>
                )
                break
            default:
                break
        }
    }

    const body = selectedTemplate.components.find((component) => component.type === "BODY")
    if (body) {
        parsedBody = body["text"]
        const bodyParams = mediaParameters?.body
        if (bodyParams && typeof bodyParams === "object") {
            Object.entries(bodyParams).forEach(([key, value]) => {
                const placeholder = `{{${parseInt(key, 10) + 1}}}`
                parsedBody = parsedBody.replaceAll(placeholder, value)
            })
        }
    }

    const footer = selectedTemplate.components.find((component) => component.type === "FOOTER")
    if (footer)
        parsedFooter = (
            <div style={{ marginTop: "1rem", color: "gray" }}>{footer.text}</div>
        )

    return (
        <Box className="summary-message-template">
            {parsedHeader ?? null}
            {parsedBody &&
                <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
                    {parsedBody}
                </pre>
            }
            {Array.isArray(attachments) && attachments.length > 0 &&
                <Box mt={2}>
                    {attachments.map((attachment, i) => (
                        <div key={i}>
                            Anexo:{" "}
                            <a href={attachment.acess_directory} target="_blank" rel="noopener noreferrer">
                                {attachment.filename}
                            </a>
                        </div>
                    ))}
                </Box>
            }
            {parsedFooter ?? null}
        </Box>
    )
}

export const WhatsappSelect = ({ selectedSender, handleNumberChange, senders,
    filteredTemplates, selectedTemplate, handleSelectedTemplate, mediaParameters,
    queues, selectedQueue, handleSelectQueue }) => {

    const [newTemplateDialog, setNewTemplateDialog] = useState(false)
    const [newTemplateLoading, setNewTemplateLoading] = useState(false)

    return (
        <Box>
            <Loading loading={newTemplateLoading} />
            <Typography className="typography-title" variant="h6" gutterBottom>
                Número de envio (remetente)
            </Typography>
            <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Número</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Número"
                    onChange={(event) => {
                        localStorage.setItem("last_template_number", event.target.value)
                        handleNumberChange(event.target.value)
                    }}
                    value={selectedSender}
                >
                    {senders.map((number, index) => (
                        <MenuItem key={index} value={number}>{number}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            {queues &&
            <>
                <Typography className="typography-title" variant="h6" gutterBottom>
                    Defina a fila de atendimento que receberá a resposta do contato
                </Typography>
                <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">Fila</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Fila"
                        onChange={handleSelectQueue}
                        value={selectedQueue}
                    >
                        <MenuItem value="">Sem fila</MenuItem>
                        {queues.map((queue, index) => (
                            <MenuItem key={index} value={queue.name}>{queue.description}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </>
            }
            <Typography className="typography-title" variant="h6" gutterBottom>
                Mensagem que deseja enviar
                {getSession().profile.enterprise.abstraction_layer && <Button onClick={() => setNewTemplateDialog(true)}>Criar template</Button>}
            </Typography>
            <Autocomplete size="small" fullWidth
                options={filteredTemplates.sort((a, b) => {
                    const groupA = a.owner_id ? 0 : 1
                    const groupB = b.owner_id ? 0 : 1
                    return groupA - groupB
                })}
                groupBy={(option) => option.owner_id ? "Meus templates" : "Templates públicos"}
                getOptionLabel={(option) => option.name ?? ""}
                value={selectedTemplate}
                onChange={(event, newValue) => handleSelectedTemplate(newValue)}
                renderInput={(params) => (
                    <TextField {...params} label="Template" variant="outlined" />
                )}
            />
            <Alert severity="info" className="template-alert-info">
                Devido à política WhatsApp Business, somente modelos de mensagem pré-aprovados podem ser enviados.
            </Alert>
            {selectedTemplate &&
                <>
                    <Typography className="typography-title" variant="h6" gutterBottom>
                        A seguir, a mensagem que seu cliente receberá
                    </Typography>
                    {selectedTemplate && renderMessage(selectedTemplate, mediaParameters)}
                </>
            }

            {newTemplateDialog &&
                <Modal
                    open={newTemplateDialog}
                    handleClose={() => setNewTemplateDialog(false)}
                    template={{}}
                    readTemplate={false}
                    copyTemplate={false}
                    categories={{
                        "MARKETING": "Marketing",
                        "UTILITY": "Utilidades",
                        "AUTHENTICATION": "Autenticação"
                    }}
                    getTemplates={() => {
                        setNewTemplateLoading(true)
                        setNewTemplateDialog(false)
                    }}
                    errorValidation={(res) => useValidationError(res.status, res.message)}
                    postProcess={(template) => checkTemplateStatus(template, handleNumberChange, setNewTemplateLoading, selectedSender)}
                />
            }
        </Box>
    )
}

const CreateCampaignModal = (props) => {
    const journeyRef = useRef("");
    const { campaigns, groups, updateCampaigns, subsObj, setLoading } = useContext(ScreenContext)

    const [campaignID, updateCampaignID] = useState(0)

    const [campaignName, updateCampaignName] = useState("")
    const [clientGroup, updateclientGroupRows] = useState([])
    const [selectedGroup, updateSelectedGroup] = useState([])
    const [enterprises, updateEnterprises] = useState([])
    const [selectedEnterprise, updateSelectedEnterprise] = useState([])

    const [selectedQueue, updateSelectedQueue] = useState(localStorage.getItem("last_template_queue"))
    const [selectedSender, updateSelectedSender] = useState("")
    const [selectedTemplate, updateSelectedTemplate] = useState("")
    const [filteredTemplates, setFilteredTemplates] = useState([])
    const [numberTemplates, setNumberTemplates] = useState([])
    const [numberLoading, setNumberLoading] = useState(false)
    const [timeSelector, updateTimeSelector] = useState("")

    const [dateTimeSelector, updateDateTimeSelector] = useState({})

    const [sendNow, updateSendNow] = useState(false)

    const [updateButtons, setUpdateButtons] = useState(false)

    const [actualStep, updateStep] = useState(0)
    const [canNext, updateCanNext] = useState(false)

    const [paramModal, updateParamModal] = useState(false)
    const [deployParameters, setDeployParameters] = useState([])

    let [parameters, updateParameters] = useState([])
    let [mediaParameters, updateMediaParameters] = useState({})

    const [allParamsFilled, updateAllParamsFilled] = useState(false)

    const [modalActions, setModalActions] = useState()

    const [ready, updateReady] = useState(false)

    const [inputValue, setInputValue] = useState('')
    const [enterpriseInputValue, setEnterpriseInputValue] = useState("")
    const [owners, updateOwners] = useState([])
    const [selectedOwner, updateSelectedOwner] = useState([])
    const [ownerInputValue, setOwnerInputValue] = useState("")

    const [platform, setPlatform] = useState('WHATSAPP')

    const [smsState, setSmsState] = useReducer(defaultReducer, {
        ...getSmsDefaultState
    })

    const [emailState, setEmailState] = useReducer(defaultReducer, {
        ...getEmailDefaultState
    })
    const [forceEmailCcCco, setForceEmailCcCco] = useState(false)

    const [scoutState, setScoutState] = useReducer(defaultReducer, {
        ...getScoutDefaultState
    })

    const [voiceState, setVoiceState] = useReducer(defaultReducer, {
        ...getVoiceCampaignDefaultState
    })
    const [voiceDestinations, setVoiceDestinations] = useState([])
    const [voiceQueues, setVoiceQueues] = useState([])

    const [testCampaignModal, setTestCampaignModal] = useState(false)
    const [testCampaignNumber, setTestCampaignNumber] = useState(null)
    const [smallLoading, setSmallLoading] = useState(false)
    const [pendingNotifications, setPendingNotifications] = useState(null)
    const [campaignCancelled, setCampaignCancelled] = useState(false)

    const [templateTab, setTemplateTab] = useState(0)
    const [stepLoading, setStepLoading] = useState(false)

    const [contactType, setContactType] = useState(props.contactType || "")
    const [contactFilter, setContactFilter] = useState("")
    const [contactFilterValue, setContactFilterValue] = useState("")
    const [contactFilters, setContactFilters] = useState([])
    const [filtersCombination, setFiltersCombination] = useState("and")
    const [phonePresence, setPhonePresence] = useState("any")

    const [reportTrigger, setReportTrigger] = useState("")
    const [reportEmail, setReportEmail] = useState("")

    const [emailTemplates, setEmailTemplates] = useState([])
    const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null)

    const [state, setState] = useReducer(lockedReducer, {
        journeys: [],
        selectedJourney: "",
        journeyColumns: [],
        selectedColumn: "",
        tags: [],
        allTags: [],
        customFields: [],
        selectedCustomFields: {},
        tagsOpen: false,
        showNewTagForm: false,
        newTag: { name: '', color: '' },
        customFieldsOpen: false,
        showNewCustomFieldForm: false,
        editingCustomField: null,
        selectOpen: false,
        showDeleteCustomFieldConfirmation: null
    })
    
    const fileInputRef = useRef(null)
    const [dragOver, setDragOver] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [importedFileCount, setImportedFileCount] = useState(null)
    const [alreadyImported, setAlreadyImported] = useState(false)

    const importLimit = getSession()?.profile?.enterprise?.settings?.crm_upload_limit || 5000

    const queues = Object.entries(props.queues)

    const [previewErrors, setPreviewErrors] = useState(0)

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                maxWidth: 250,
            },
        },
    };

    const newTagsRef = useRef(null)
    const newCustomFieldsRef = useRef(null)
    const stateRef = useRef(state)
    const pendingJourneyColumnRef = useRef(null)

    const EXCLUSIVE_FILTER = "enterprises_contact_group";

    const hasExclusiveFilter = contactFilters.some(f => f.field === EXCLUSIVE_FILTER);
    const hasAnyOtherFilter = contactFilters.some(f => f.field !== EXCLUSIVE_FILTER);

    const fetchEmailTemplates = async () => {
        const enterpriseId = getSession().profile.enterprise.id;

        const response = await api.get(
            `api/enterprises/${enterpriseId}/email_templates/`
        );

        if (response.status === 200) {
            const templates = response.data;

            setEmailTemplates(templates);

            const template = templates.find(
                (item) => String(item.id) === String(emailState.email_template_id)
            );

            setSelectedEmailTemplate(template || null);
        }
    };

    const handleEmailTemplateChange = (templateId) => {
        if (!templateId) {
            setSelectedEmailTemplate(null);
            setEmailState({
                email_template_id: null,
                subject: '',
            });

            if (typeof window.setCleanEmailPredefinedMessage === 'function') {
                window.setCleanEmailPredefinedMessage('');
            }

            return;
        }

        const template = emailTemplates.find(
            (item) => String(item.id) === String(templateId)
        );

        if (!template) return;

        setSelectedEmailTemplate(template);

        const subject = template.subject || '';
        let content = template.html_content || '';

        if (template.content_type === 'text') {
            content = content
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/\r\n|\r|\n/g, '<br>');
        }

        setEmailState({
            email_template_id: template.id,
            subject,
        });

        if (typeof window.setCleanEmailPredefinedMessage === 'function') {
            window.setCleanEmailPredefinedMessage(content);
        }
    };

    useEffect(() => {
        fetchEmailTemplates()
    }, [])

    // 1) Se já existe o exclusivo, nenhum outro pode ser escolhido
    // 2) Se já existe qualquer outro, o exclusivo não pode ser escolhido
    const isFilterOptionDisabled = (value) => {
        if (!value) return false;
        if (value === EXCLUSIVE_FILTER) return hasAnyOtherFilter || hasExclusiveFilter;
        return hasExclusiveFilter;
    };

    // Bloqueia clique no "Adicionar filtro" (proteção extra)
    const isAddBlocked = (field) => (
        (hasExclusiveFilter && field !== EXCLUSIVE_FILTER) ||
        (hasAnyOtherFilter && field === EXCLUSIVE_FILTER)
    );

    useEffect(() => {
        updateReady(true)
        delayedChange("", "group", updateclientGroupRows, setSmallLoading)
        delayedChange("", "enterprise", updateEnterprises, setSmallLoading)
        delayedChange("", "user", updateOwners, setSmallLoading)
        fetchJourneys()
    }, [])

    const clearTextLocal = (value) => {
        return value.replace(/[^a-zA-Z0-9,;|@._"'\- \u00C0-\u024F:\/\r\n]+/g, '')
    }
    const clearNumberLocal = value => value.replace(/[^0-9]+/g, '')

    const detectSeparator = (text) => {
        const lines = text.split(/\r?\n/).filter(l => l.trim().length > 0)
        if (lines.length === 0) return ','
        const first = lines[0]
        const separators = [',',';','|','\t']
        let best = ','
        let bestCount = -1
        separators.forEach((sep) => {
            let real_sep = sep
            if (sep === ',') real_sep = /,(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/
            const fields = first.split(real_sep).map(f => f.toLowerCase().replace(/[^a-z0-9_]/g, ''))
            let count = 0
            if (fields.includes('nome') || fields.includes('name')) count++
            if (fields.includes('telefone') || fields.includes('telefone') || fields.includes('telephone') || fields.includes('phone')) count++
            if (fields.includes('email')) count++
            if (count > bestCount) {
                bestCount = count
                best = sep
            }
        })
        return best
    }

    const parseCSVToPreview = (text, separator) => {
        const rawdata = text.split(/\r?\n/)
        if (rawdata.length === 0) return []
        let real_separator = separator
        if (separator === ',') real_separator = /,(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/

        const header = rawdata[0].split(real_separator).map(h => (h || '').trim())
        const idx = {}
        header.forEach((h, i) => {
            const lh = (h || '').toLowerCase()
            if (lh === 'nome' || lh === 'name') idx.nome = i
            if (lh === 'email' || lh === 'e-mail') idx.email = i
            if (lh === 'telefone' || lh === 'phone' || lh === 'telephone') idx.telefone = i
        })

        if (!('nome' in idx) || (!('telefone' in idx) && !('email' in idx))) {
            setSelectedFile(null)
            setAlreadyImported(false)
            return { error: 'Não há cabeçalhos válidos (é necessário Nome e (Telefone ou Email))' }
        }

        const rows = rawdata.slice(1).map((row, i) => {
            if (!row || !row.trim()) return null
            const parts = clearTextLocal(row).split(real_separator)
            return {
                id: i,
                nome: parts[idx.nome] ? parts[idx.nome].trim() : '',
                email: idx.email !== undefined && parts[idx.email] ? parts[idx.email].trim() : '',
                telefone: idx.telefone !== undefined && parts[idx.telefone] ? clearNumberLocal(parts[idx.telefone]) : '',
            }
        }).filter(r => r)

        let erroCount = 0
        rows.forEach(r => { if (!r.telefone && !r.email) { r.error = true; erroCount++ } })

        return { rows: rows, errors: erroCount }
    }

    const handleCampaignFileSelect = (file) => {
        if (!file) return
        const ext = file.name.split('.').pop().toLowerCase()
        
        if (ext === 'xlsx' || ext === 'xls') {

            uploadFileToServer(file)
            return
        }

        const reader = new FileReader()
        reader.onload = function(e) {
            const text = e && e.target && e.target.result
            if (!text) {
                useNotification('Ops!', 'Não foi possível ler o arquivo', 'danger')
                return
            }
            const sep = detectSeparator(text)
            const parsed = parseCSVToPreview(text, sep)
            if (parsed.error) {
                useNotification('Ops!', parsed.error, 'danger')
                return
            }
            const rows = parsed.rows.slice(0, importLimit)
            setPreviewErrors(parsed.errors)
            const validCount = rows.length - parsed.errors
            setImportedFileCount(validCount)
        }
        reader.readAsText(file)
    }

    const uploadFileToServer = (file) => {
        const fileFormData = new FormData()
        fileFormData.append('file', file)
        api.post(`/api/enterprises/${props.enterpriseId}/campaign/import_contacts/`, fileFormData)
            .then((fileResponse) => {
                if (fileResponse.status === 201) {
                    const renamedFile = new File([file], fileResponse.data.actual_name, { type: file.type })
                    setSelectedFile(renamedFile)
                    setImportedFileCount(fileResponse.data.contacts_count)
                    setAlreadyImported(true)
                    setPreviewErrors(0)
                    // useNotification('Sucesso', `${fileResponse.data.contacts_count} contatos detectados no arquivo.`, 'success')
                } else {
                    useNotification('Ops!', 'Falha ao importar arquivo', 'danger')
                }
            })
            .catch(() => {
                useNotification('Ops!', 'Falha ao enviar arquivo', 'danger')
            })
    }

    const confirmUploadSelectedFile = async () => {
        if (!selectedFile) {
            // if file hasn't been uploaded to server yet, upload the original selectedFile
            const inputFile = fileInputRef.current?.files?.[0]
            if (!inputFile) {
                useNotification('Ops!', 'Nenhum arquivo selecionado', 'danger')
                return
            }
            await uploadFileToServer(inputFile)
            return
        }
        // already have selectedFile (maybe pre-uploaded), nothing to do
        return
    }

    useEffect(() => {
        stateRef.current = state
    }, [state])

    const fetchJourneys = async () => {
        const response = await api.get(`/api/enterprises/${props.enterpriseId}/journeys/`)
        if (response.status === 200) {
            setState({ journeys: response.data.results || response.data })
        }
    }

    const getVoiceResourceError = (error, fallback) => {
        return error?.response?.data?.error || error?.response?.data?.detail || fallback
    }

    const fetchVoiceResources = async () => {
        const params = {
            telephony_backend: voiceState.telephony_backend || 'EXTERNAL'
        }
        try {
            const destinationsResponse = await api.get(`/api/enterprises/${props.enterpriseId}/campaign/voice_destinations/`, { params })
            if (destinationsResponse.status === 200) {
                setVoiceDestinations(destinationsResponse.data.results || destinationsResponse.data)
            }
        } catch (error) {
            setVoiceDestinations([])
            useNotification('Ops!', getVoiceResourceError(error, 'Não foi possível carregar as URAs de voz.'), 'danger')
        }

        try {
            const queuesResponse = await api.get(`/api/enterprises/${props.enterpriseId}/campaign/voice_queues/`, { params })
            if (queuesResponse.status === 200) {
                setVoiceQueues(queuesResponse.data.results || queuesResponse.data)
            }
        } catch (error) {
            setVoiceQueues([])
            useNotification('Ops!', getVoiceResourceError(error, 'Não foi possível carregar as filas de voz.'), 'danger')
        }
    }

    const fetchJourneyColumns = async (journeyId) => {
        const response = await api.get(`/api/enterprises/${props.enterpriseId}/journeys/${journeyId}/columns/`)
        if (response.status === 200) {
            const columns = response.data.results || response.data
            const pendingColumn = pendingJourneyColumnRef.current
            pendingJourneyColumnRef.current = null
            const pendingIsValid = pendingColumn != null && columns.some(each => String(each.id) === String(pendingColumn))
            const defaultColumn = pendingIsValid ? pendingColumn : (columns.length > 0 ? columns[0].id : "")
            setState({ 
                journeyColumns: columns,
                selectedColumn: defaultColumn
            })
        }
    }

    const fetchTags = async () => {
        const response = await api.get(`/api/enterprises/${props.enterpriseId}/journeys/${state.selectedJourney}/tags/`)
        if (response.status === 200) {
            setState({ allTags: response.data.results || response.data })
        }
    }

    const fetchCustomFields = async () => {
        const response = await api.get(`/api/enterprises/${props.enterpriseId}/journeys/${state.selectedJourney}/custom_fields/`)
        if (response.status === 200) {
            const fields = response.data.results || response.data || []
            setState({ customFields: Array.isArray(fields) ? fields : [] })
        }
    }

    useEffect(() => {
        if (state.selectedJourney) {
            fetchJourneyColumns(state.selectedJourney)
            fetchTags()
            fetchCustomFields()
        } else {
            setState({ 
                journeyColumns: [],
                selectedColumn: "",
                allTags: [],
                selectedCustomFields: {},
                tags: [],
                customFields: [],
                editingCustomField: null
            })
        }
    }, [state.selectedJourney])

    useEffect(() => {
        if (platform === 'VOICE') {
            fetchVoiceResources()
        }
    }, [platform, voiceState.telephony_backend])

    useEffect(() => {
    }, [state.selectedColumn])

    const handleSaveCustomField = async (fieldData) => {
        const response = await api.post(`/api/enterprises/${props.enterpriseId}/journeys/${state.selectedJourney}/custom_fields/`, fieldData)
        if (response.status === 201) {
            setState({ customFields: [...state.customFields, response.data], showNewCustomFieldForm: false })
            useNotification("Sucesso", "Campo personalizado criado com sucesso", "success")
        }
    }

    const handleEditCustomField = async (fieldData) => {
        const response = await api.patch(`/api/enterprises/${props.enterpriseId}/journeys/${state.selectedJourney}/custom_fields/${state.editingCustomField.id}/`, fieldData)
        if (response.status === 200) {
            setState({
                customFields: state.customFields.map(field => field.id === state.editingCustomField.id ? response.data : field),
                editingCustomField: null,
                showNewCustomFieldForm: false
            })
            useNotification("Sucesso", "Campo personalizado atualizado com sucesso", "success")
        }
    }

    const deleteCustomField = async (fieldId) => {
        const enterpriseId = props.enterpriseId || getSession().profile.enterprise.id
        const response = await api.delete(`/api/enterprises/${enterpriseId}/journeys/${state.selectedJourney}/custom_fields/${fieldId}/`)

        if (response.status === 204) {
            const updatedFields = (state.customFields || []).filter(field => field.id !== fieldId)
            const updatedSelected = { ...(state.selectedCustomFields || {}) }
            delete updatedSelected[fieldId]
            setState({ customFields: updatedFields, selectedCustomFields: updatedSelected })
            useNotification("Sucesso", "Campo personalizado removido com sucesso", "success")
        } else {
            useNotification("Erro", "Falha ao remover campo personalizado", "danger")
        }
    }


    //Custom logic to save in between steps without modifying old logic.
    // 'create' for the first step
    // 'activate' for the last step
    // 'none' for any step.
    const onNext = async (value) => {
        const validation = changeData(value - 1)
        if (!validation)
            return false

        if (value == 1 && platform === 'VOICE' && campaignID === 0) {
            return true
        }
        if (value == 1 && platform !== 'VOICE') {
            const res = await submit('create')
            return res
        }
        if (value == 2 && platform === 'VOICE' && campaignID === 0) {
            const res = await submit('create')
            return res
        }
        const res = await submit('none')
        return res
    }

    const submit = async (command) => {
        if (command != 'create' && campaignID === 0)
            return
        const posturl = `/api/enterprises/${props.enterpriseId}/campaign/`
        const patchurl = `/api/enterprises/${props.enterpriseId}/campaign/${campaignID}/`
        // const testUrl = `/api/whatsapp/medianotification/`
        const testUrl = `/api/enterprises/${props.enterpriseId}/campaign/test/`
        const isPeriodic = timeSelector === 'periodic' ? true : false
        const isVoiceContinuous = platform === 'VOICE' && voiceState.mode === 'CONTINUOUS'
        const isVoiceBatch = platform === 'VOICE' && !isVoiceContinuous
        const shouldActivate = command == 'activate' || command == 'test-activate'
        const shouldStartVoiceNow = platform === 'VOICE' && (isVoiceContinuous || sendNow)
        var daylist = typeof (dateTimeSelector.DAY) !== 'object' ? dateTimeSelector.DAY : dateTimeSelector.DAY.join()
        var monthlist = typeof (dateTimeSelector.MONTH) !== 'object' ? dateTimeSelector.MONTH : dateTimeSelector.MONTH.map(item => JSON.parse(item).key).join()
        var weekdaylist = typeof (dateTimeSelector.WEEKDAYS) !== 'object' ? dateTimeSelector.WEEKDAYS : dateTimeSelector.WEEKDAYS.map(item => JSON.parse(item).key).join()
        const queue = selectedQueue !== null ? selectedQueue.split('_')[1] : ""
        var range = '*'
        var year = dateTimeSelector.YEAR
        const getVoiceConfigPayload = () => ({
            ...voiceState,
            mode: voiceState.mode || 'BATCH',
            telephony_backend: voiceState.telephony_backend || 'EXTERNAL',
            destination_type: 'URA',
            destination_mcdu: voiceState.destination_mcdu ? String(voiceState.destination_mcdu) : '',
            queue_id: voiceState.queue_id || null,
            dial_attempt: Number(voiceState.dial_attempt),
            retry_interval: Number(voiceState.retry_interval),
            timeout: Number(voiceState.timeout),
            simultaneous_calls: Number(voiceState.simultaneous_calls),
            call_factor: Number(voiceState.call_factor),
            ads_billsec_limit: Number(voiceState.ads_billsec_limit)
        })

        if (!selectedTemplate && actualStep >= 1 && platform === 'WHATSAPP') {
            updateCanNext(false)
            useNotification(
                'Falha!',
                `Por favor escolha um template válido`,
                'danger'
            )
            return false
        }

        if (!isVoiceContinuous && !isPeriodic && actualStep >= 4 && !sendNow) {
            const today = new Date()
            if (dateTimeSelector.DATE < today) {
                updateCanNext(false)
                useNotification(
                    'Falha!',
                    `Por favor escolha um horário maior que o atual`,
                    'danger'
                )
                return false
            }

        }
        if (!isVoiceContinuous && dateTimeSelector.PERIOD == 1) {
            range = dateTimeSelector.RANGE
            year = '0'
            monthlist = '*'
            weekdaylist = '*'
            const today2 = new Date()
            if (dateTimeSelector.DATE < today2) {
                updateCanNext(false)
                useNotification(
                    'Falha!',
                    `Por favor escolha um horário maior que o atual`,
                    'danger'
                )
                return false
            }

        }


        let formdata = {}
        const newParameters = deployParameters
        if (newParameters && Object.values(newParameters).length > 0 && actualStep === 1 && platform === 'WHATSAPP') {
            formdata = new FormData()
            if ('headerfile' in newParameters)
                formdata.append('headerfile', newParameters.headerfile)
            if ('headerbody' in newParameters)
                formdata.append('headerbody', newParameters.headerbody)
            if ('body' in newParameters)
                Object.values(newParameters.body).map(p => formdata.append('body', p))
            if ('buttons' in newParameters)
                formdata.append('buttons', newParameters.buttons)

            if (!('headerfile' in newParameters) && 'headerURL' in newParameters)
                formdata.append('headerURL', newParameters.headerURL)

            formdata.append('parameters', 'renew')
            formdata.append('queue', queue ? queue : '')
            formdata.append('sender', selectedSender ? selectedSender : '')
            formdata.append('template', selectedTemplate ? JSON.stringify(selectedTemplate) : '')
            formdata.append('step', actualStep + 1)
            formdata.append('platform', platform)
        } else if (actualStep === 1 && platform === 'SCOUT' && scoutState.format === MessageFormat.MEDIA) {
            formdata = new FormData()
            formdata.append('name', campaignName)
            if (selectedGroup && selectedGroup.length > 0)
                formdata.append('group', selectedGroup.map(each => each.id))
            if (props.selectedContacts && props.selectedContacts.length > 0)
                formdata.append('contact_ids', props.selectedContacts)
            formdata.append('queue', queue)
            formdata.append('sender', selectedSender)
            formdata.append('scout_media', scoutState.media)
            formdata.append('template', scoutState ? JSON.stringify(scoutState) : '')
            if (year)
                formdata.append('year', sendNow ? '0' : year)
            if (monthlist)
                formdata.append('months', monthlist)
            if (weekdaylist)
                formdata.append('week_days', weekdaylist)
            if (daylist)
                formdata.append('days', daylist)
            if (dateTimeSelector && dateTimeSelector.HOURS)
                formdata.append('hour', dateTimeSelector.HOURS)
            if (dateTimeSelector && dateTimeSelector.MINUTES)
                formdata.append('minutes', dateTimeSelector.MINUTES)
            formdata.append('periodic', isPeriodic)
            formdata.append('active', command == 'activate' || command == 'test-activate' ? true : false)
            formdata.append('_range', range.toString())
            formdata.append('run_now', sendNow)
            formdata.append('step', actualStep + 1)
            formdata.append('platform', platform)

        } else {

            let setTemplate = ''
            let scout_media = null

            if (platform === 'WHATSAPP')
                setTemplate = selectedTemplate.name
            else if (platform === 'SMS')
                setTemplate = JSON.stringify(smsState)
            else if (platform === 'EMAIL') {
                if (emailState.emailMessageData && emailState.emailMessageData.attachments?.filter(each => !each.loaded)?.length) {
                    setStepLoading(true)
                    const returnData = await postEmailAttachments(emailState.emailMessageData.bodyTextContent, emailState.emailMessageData.attachments, emailState.email)
                    setStepLoading(false)
                    if (returnData === -1) {
                        return
                    }
                    const attachmentregex = /\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g
                    const attachments_obj = getAttachments(attachmentregex, returnData)
                    emailState.emailMessageData.bodyTextContent = attachments_obj.response
                    emailState.emailMessageData.attachments = [...attachments_obj.data.map(e => ({ ...e, loaded: true })), ...emailState.emailMessageData.attachments?.filter(each => each.loaded)]
                }

                setTemplate = JSON.stringify({
                    ...emailState,
                    cc: normalizeEmailRecipients(emailState.cc),
                    cco: normalizeEmailRecipients(emailState.cco),
                })
                if ('setEmailData' in window)
                    window.setEmailData(emailState.emailMessageData)
            } else if (platform === 'SCOUT') {
                scout_media = scoutState.media
                setTemplate = JSON.stringify(scoutState)
            }

            if (testCampaignNumber && command == "test-activate") {
                formdata = {
                    id: campaignID,
                    name: campaignName,
                    queue_name: queue,
                    sender: selectedSender,
                    template: platform === 'VOICE' ? null : setTemplate,
                    scout_media: scout_media,
                    run_now: true,
                    platform: platform,
                    to: platform === 'EMAIL' ? testCampaignNumber.trim() : testCampaignNumber,
                    from: selectedSender,
                }
            } else {
                formdata = {
                    name: campaignName,
                    group: isVoiceContinuous ? [] : contactFilter === "contact_group" ? selectedGroup.map(each => each.id) : [],
                    contact_enterprises: isVoiceContinuous ? [] : contactFilter === "contact_enterprise" ? selectedEnterprise.map(each => each.id) : [],
                    contact_type: isVoiceContinuous ? '' : contactType,
                    contact_file: isVoiceContinuous ? undefined : selectedFile?.name,
                    contact_filter: isVoiceContinuous ? '' : contactFilter,
                    contact_filter_value: isVoiceContinuous ? '' : contactFilterValue,
                    contact_filters: isVoiceContinuous ? null : getAllFilters().length > 0 ? getAllFilters() : null,
                    filters_combination: 'and',
                    phone_presence: phonePresence,
                    report_trigger: reportTrigger,
                    report_email: reportEmail?.trim(),
                    contact_ids: isVoiceContinuous ? [] : props.selectedContacts,
                    queue: platform === 'VOICE' ? "" : queue ?? "",
                    sender: selectedSender,
                    template: platform === 'VOICE' ? null : setTemplate,
                    scout_media: scout_media,
                    year: isVoiceContinuous ? '0' : sendNow ? '0' : year,
                    months: isVoiceContinuous ? '*' : monthlist,
                    week_days: isVoiceContinuous ? '*' : weekdaylist,
                    days: isVoiceContinuous ? '*' : daylist,
                    hour: isVoiceContinuous ? '*' : dateTimeSelector.HOURS,
                    minutes: isVoiceContinuous ? '*' : dateTimeSelector.MINUTES,
                    periodic: isVoiceContinuous ? false : isPeriodic,
                    active: isVoiceBatch ? shouldActivate && !sendNow : shouldActivate,
                    _range: range.toString(),
                    run_now: platform === 'VOICE' ? false : sendNow,
                    step: actualStep + 1,
                    platform: platform,
                    journey: stateRef.current.selectedJourney ? parseInt(stateRef.current.selectedJourney, 10) : null,
                    journey_column_id: stateRef.current.selectedColumn ? parseInt(stateRef.current.selectedColumn, 10) : null,
                    journey_tags: stateRef.current.tags,
                    journey_custom_fields: stateRef.current.selectedCustomFields,
                    force_email_cc_cco: forceEmailCcCco,
                    voice_config: platform === 'VOICE' && actualStep > 0 ? getVoiceConfigPayload() : null,
                }

                if (!isVoiceContinuous && contactType === "imported" && !alreadyImported && actualStep >= 3) {
                    const fileFormData = new FormData()
                    fileFormData.append("file", selectedFile)
                    setStepLoading(true)
                    const fileResponse = await api.post(`/api/enterprises/${props.enterpriseId}/campaign/import_contacts/`, fileFormData)
                    setStepLoading(false)
                    if (fileResponse.status !== 201) {
                        if (fileResponse.status === 400) {
                            useNotification("Atenção", "Somente arquivos xlsx ou csv são permitidos.", "warning")
                            return
                        }
                        useNotification("Ops!", "Algo deu errado ao importar o arquivo.", "danger")
                        return
                    }
                    const renamedFile = new File([selectedFile], fileResponse.data.actual_name, { type: selectedFile.type })
                    setSelectedFile(renamedFile)
                    setImportedFileCount(fileResponse.data.contacts_count)
                    formdata["contact_file"] = fileResponse.data["actual_name"]
                    setAlreadyImported(true)
                }
            }

            // If we don't have mediaParameters, we should change parameters to empty 
            // This means, we are changing to a new template that doesn't require parameters.
            if (actualStep == 1 && (!mediaParameters || Object.values(mediaParameters).length == 0)) {
                formdata.parameters = '[]'
            }
        }

        var response = ''
        if (testCampaignNumber && command == "test-activate") {
            response = await api.post(testUrl, formdata)
            if (response.status === 200)
                useNotification(
                    'Enviado!',
                    `O teste foi enviado para o ${platform === 'EMAIL' ? 'email' : 'número'} de destino com sucesso. Caso não receba a mensagem, acesse a tela de notificações e verifique o status para saber mais detalhes.`,
                    'success'
                );
            else {
                useNotification(
                    'Ops!',
                    response.data?.message || 'Ocorreu um erro com a requisição',
                    'danger'
                );
            }
            return
        } else if (command == 'create' && !campaignID) {
            setStepLoading(true)
            const { sender, queue, template, ...payload } = formdata
            var response = await api.post(posturl, payload)
            setStepLoading(false)
            if (response.status === 201) {
                updateCampaignID(response.data.id)
                updateCampaigns(prevState => subsObj(prevState, response.data).sort((x, y) => x > y ? 1 : -1))
            }
        }
        else {
            setStepLoading(true)
            var response = await api.patch(patchurl, formdata)
            setStepLoading(false)
            if (response.status === 200) {
                updateCampaigns(prevState => subsObj(prevState, response.data).sort((x, y) => x > y ? 1 : -1))
            }
        }

        if (response.status === 400) {
            let message = 'Ocorreu um erro com a requisição.'
            if ('non_field_errors' in response.data && response.data.non_field_errors)
                message = 'Já existe uma campanha com esse nome nessa empresa.'
            if ('file' in response.data)
                message = 'O formato do documento anexado aos parâmetros não é permitido.'
            useNotification(
                'Ops!',
                message,
                'danger'
            );
            return

        }
        else if (response.status == 403) {
            let message = 'Você não tem permissão para realizar essa ação.'
            useNotification(
                'Ops!',
                message,
                'danger'
            );
            return
        }

        if (command == 'activate' || command == 'test-activate') {
            if (platform === 'VOICE') {
                if (!shouldStartVoiceNow) {
                    useNotification(
                        'Sucesso!',
                        'Campanha de voz agendada.',
                        'success'
                    );
                    const newres = await props.submit()
                    return true
                }
                const currentCampaignId = campaignID || response.data?.id
                setStepLoading(true)
                try {
                    const startResponse = await api.post(`/api/enterprises/${props.enterpriseId}/campaign/${currentCampaignId}/voice_start/`)
                    setStepLoading(false)
                    if (startResponse.status === 200) {
                        useNotification(
                            'Sucesso!',
                            startResponse.data?.message || 'Campanha de voz iniciada.',
                            'success'
                        );
                        updateVoiceCampaignRow(currentCampaignId, startResponse.data)
                        const newres = await props.submit()
                        return true
                    }
                    useNotification(
                        'Ops!',
                        startResponse.data?.error || 'Não foi possível iniciar a campanha de voz.',
                        'danger'
                    );
                    return false
                } catch (error) {
                    setStepLoading(false)
                    useNotification(
                        'Ops!',
                        error?.response?.data?.error || 'Não foi possível iniciar a campanha de voz.',
                        'danger'
                    );
                    return false
                }
            }
            useNotification(
                'Sucesso!',
                'Campanha concluída.',
                'success'
            );

            const newres = await props.submit()
            return true
        }
        return true
    }

    const changeData = (targetstep = 0) => {
        setUpdateButtons(p => !p)

        if (actualStep == 0) {
            if (campaignName.length == 0) {
                return false
            }
        }

        if (actualStep == 1 || targetstep >= 1) {
            if (platform === 'WHATSAPP') {
                if (selectedSender.length == 0 || selectedTemplate.length == 0) {
                    return false
                }
            }
            else if (platform === 'SMS') {
                const res = ShouldSendSms(smsState)
                if (res)
                    return false
            }
            else if (platform === 'EMAIL') {
                const res = ShouldSendEmail(emailState)
                if (res)
                    return false
            }
            else if (platform === 'SCOUT') {
                const res = ShouldSendScout(scoutState)
                if (res)
                    return false
            }
            else if (platform === 'VOICE' && actualStep >= 1) {
                const res = ShouldSendVoice(voiceState)
                if (res)
                    return false
            }
        }

        if ((actualStep == 3 || targetstep >= 3) && platform === 'VOICE' && voiceState.mode === 'CONTINUOUS') {
            return true
        }

        if (actualStep == 3 || targetstep >= 3) {
            if (props.selectedContacts && props.selectedContacts.length > 0)
                return true
            if (!contactType)
                return false
            if (contactType === "filtered") {
                if (contactFilters.length > 0)
                    return true
                if (contactFilter === 'has_phone' || contactFilter === 'no_phone')
                    return true
                if (contactFilter === "contact_group" && selectedGroup.length > 0)
                    return true
                if (contactFilter === "contact_enterprise" && selectedEnterprise.length > 0)
                    return true
                if (contactFilter === "contact_owner" && selectedOwner.length > 0)
                    return true
                if ((contactFilter === 'email' || contactFilter === 'telephone' || 
                     contactFilter === 'created_gte' || contactFilter === 'created_lte' || 
                     contactFilter === 'birthday') && contactFilterValue)
                    return true
                if (platform === "EMAIL" && contactFilter === "enterprises_contact_group" && selectedGroup.length > 0)
                    return true
                // Nenhum filtro válido
                return false
            }
        }

        if ((actualStep == 4 || targetstep >= 4) && platform === 'VOICE' && voiceState.mode === 'CONTINUOUS') {
            return true
        }

        if (actualStep == 4 || targetstep >= 4) {
            if (timeSelector.length == 0)
                return false
            else {
                const isPeriodic = timeSelector === 'periodic' ? true : false
                if (!isPeriodic && !sendNow && (dateTimeSelector.LITERAL === "Invalid Date" || Object.entries(dateTimeSelector).length === 0))
                    return false
                else if (isPeriodic && !sendNow && Object.entries(dateTimeSelector).length === 0)
                    return false
            }
        }

        return true
    }

    const handleSelectedTemplate = template => {

        if (!template) return
        updateMediaParameters({})
        setDeployParameters([])

        const requiredParameters = []
        if (template.components.length == 1 && template.components[0].type == 'BODY') {
            let amount = matchRegLen(template.components[0].text)
            if (amount)
                requiredParameters.push(
                    {
                        type: 'BODY',
                        amount: amount
                    }
                )
        }
        else {
            template.components.map(component => {
                let amount = 0
                if (component.type == 'HEADER') {
                    amount = 1
                    if (component.format == 'TEXT')
                        amount = matchRegLen(component.text)
                    if (amount)
                        requiredParameters.push({
                            type: component.type,
                            format: component.format,
                            amount: amount
                        })
                }
                else if (component.type == 'BODY') {
                    amount = matchRegLen(component.text)
                    if (amount)
                        requiredParameters.push(
                            {
                                type: 'BODY',
                                amount: amount
                            }
                        )
                }

                else if (component.type == 'BUTTONS') {
                    amount = 0
                    component.buttons.map(button => {
                        if (button.type === 'URL')
                            amount += matchRegLen(button.url)
                    })
                    if (amount)
                        requiredParameters.push(
                            {
                                type: 'BUTTONS',
                                amount: amount
                            }
                        )
                }

            })
        }

        if (requiredParameters.length > 0) {
            updateParamModal(true)
            updateParameters(requiredParameters)
            updateSelectedTemplate(template)
            return
        }
        updateSelectedTemplate(template)

    }

    const handleParamGoBack = () => {
        updateParamModal(false)
        updateParameters([])
        updateMediaParameters({})
        updateSelectedTemplate('')
    }

    const checkParameters = (value) => {
        updateAllParamsFilled(value)
        setDeployParameters(mediaParameters)
    }

    const handleChangeGroup = (event) => {
        const {
            target: { value },
        } = event;
        updateSelectedGroup(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    const recoverCampaignData = async (id) => {
        //IDK why it works with await, but doesn't without it.
        const response = await campaigns.filter(campaign => campaign.id === id).pop()
        if (response.length === 0)
            return
        setForceEmailCcCco(Boolean(response.force_email_cc_cco))

        const periods = [
            'Diariamente',
            'No intervalo de dias',
            'Nos dias da semana selecionados',
            'Nos meses selecionados'
        ]

        const possibleWeekdays = [
            { key: 0, value: 'Segunda-feira' },
            { key: 1, value: 'Terça-feira' },
            { key: 2, value: 'Quarta-feira' },
            { key: 3, value: 'Quinta-feira' },
            { key: 4, value: 'Sexta-feira' },
            { key: 5, value: 'Sábado' },
            { key: 6, value: 'Domingo' }
        ]
        const possibleMonths = [
            { key: 1, value: 'Janeiro' },
            { key: 2, value: 'Fevereiro' },
            { key: 3, value: 'Março' },
            { key: 4, value: 'Abril' },
            { key: 5, value: 'Maio' },
            { key: 6, value: 'Junho' },
            { key: 7, value: 'Julho' },
            { key: 8, value: 'Agosto' },
            { key: 9, value: 'Setembro' },
            { key: 10, value: 'Outubro' },
            { key: 11, value: 'Novembro' },
            { key: 12, value: 'Dezembro' }
        ]

        //const recoveredQueue = queues.find(each => each[1].includes(response.queue))
        const recoveredSender = props.senders.find(each => each === response.sender)

        //Fixing polymorfism
        let recoveredTemplate = ''
        if (response.platform === 'WHATSAPP') {
            const foundTemplate = recoveredSender ? await handleNumberChange(recoveredSender) : props.templates
            recoveredTemplate = foundTemplate.find(each => each.name === response.template)
        }
        else if (response.platform === 'SMS') {
            recoveredTemplate = ''
            const smsTemplate = typeof response.template === 'string' ? JSON.parse(response.template) : response.template
            setSmsState(smsTemplate)
        }
        else if (response.platform === 'EMAIL') {
            const attachmentregex = /\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g
            recoveredTemplate = ''
            // Template EMAIL é armazenado como JSON
            const emailTemplate = typeof response.template === 'string' ? JSON.parse(response.template) : response.template
            if (emailTemplate && emailTemplate.emailMessageData) {
                const attachments_obj = getAttachments(attachmentregex, emailTemplate.emailMessageData.bodyTextContent)
                emailTemplate.emailMessageData.bodyTextContent = attachments_obj.response
                emailTemplate.emailMessageData.attachments = [...attachments_obj.data.map(each => ({ ...each, loaded: true })), ...(emailTemplate.emailMessageData.attachments || [])]
                setEmailState(emailTemplate)
            }
        }
        else if (response.platform === 'SCOUT') {
            const scoutTemplate = typeof response.template === 'string' ? JSON.parse(response.template) : response.template
            setScoutState(scoutTemplate)
        }
        else if (response.platform === 'VOICE') {
            recoveredTemplate = ''
            setVoiceState({
                ...getVoiceCampaignDefaultState,
                ...(response.voice_config || {})
            })
        }

        let recoveredParams = ''
        const newobj = {}
        const parsedParams = typeof response.parameters === 'string' ? JSON.parse(response.parameters) : response.parameters
        if (Array.isArray(parsedParams)) {
            parsedParams.map(obj => {
                const [key, value] = Object.entries(obj).pop()
                Array.isArray(value) ? newobj[key] = { ...value } : newobj[key] = value
            })
        }
        recoveredParams = newobj
        updateMediaParameters(recoveredParams)

        // }  //new mode      
        const recoveredPeriodic = response.periodic === true ? 'periodic' : 'once'

        var recoveredPeriod = -1
        var recoveredLiteral = ''
        var recoverdedDate = ''

        var recoveredWeekdays = response.week_days
        var recoveredMonths = response.months
        var recoveredRange = response._range == '*' ? ['', ''] : response._range.split(',')

        if (recoveredPeriodic === 'periodic') {
            const recoveredWeekdayKeys = splitCronList(response.week_days)
            const recoveredMonthKeys = splitCronList(response.months)

            var recoveredWeekdays = response.week_days == '*' ? '*' : possibleWeekdays.filter(each =>
                recoveredWeekdayKeys.includes(String(each.key))
            ).map(each => JSON.stringify(each)
            )

            var recoveredMonths = recoveredMonths == '*' ? '*' : possibleMonths.filter(each =>
                recoveredMonthKeys.includes(String(each.key))
            ).map(each => JSON.stringify(each)
            )



            if (response.days === '*/1') {
                var recoveredPeriod = 0
            }
            else if (response._range !== '*') {
                var recoveredPeriod = 1
                var recoveredLiteral = ': ' +
                    new Date(recoveredRange[0] + 'T12:00')
                        .toLocaleDateString()
                    + ' até '
                    + new Date(recoveredRange[1] + 'T12:00')
                        .toLocaleDateString()
            }

            else if (response.week_days !== '*') {
                var recoveredPeriod = 2
                var recoveredLiteral = ': ' + recoveredWeekdays.map(item => JSON.parse(item).value).join(', ')
            }

            else if (response.months !== '*') {
                var recoveredPeriod = 3
                var recoveredLiteral = ': ' + recoveredMonths.map(item => JSON.parse(item).value).join(', ') + ' no dia ' + response.days
            }


            var recoveredLiteral = periods[recoveredPeriod] + recoveredLiteral + ` às ${response.hour}:${response.minutes}`
        }
        else {
                const yearVal = parseInt(response.year, 10)
                const monthVal = Array.isArray(recoveredMonths) ? parseInt(recoveredMonths[0], 10) : parseInt(recoveredMonths, 10)
                const dayVal = parseInt(response.days, 10)
                const hourVal = parseInt(response.hour, 10)
                const minVal = parseInt(response.minutes, 10)

                if ([yearVal, monthVal, dayVal, hourVal, minVal].some(v => isNaN(v))) {
                    recoveredLiteral = ''
                    recoverdedDate = ''
                } else {
                    recoverdedDate = new Date(yearVal, monthVal - 1, dayVal, hourVal, minVal)
                    recoveredLiteral = recoverdedDate.toLocaleString()
                }
        }

        const recoveredDateTimeSelector = response.year !== 0 ?
            {
                YEAR: response.year,
                MONTH: recoveredMonths,
                DAY: response.days,
                HOURS: response.hour,
                MINUTES: response.minutes,
                WEEKDAYS: recoveredWeekdays,
                PERIOD: recoveredPeriod,
                LITERAL: recoveredLiteral,
                RANGE: recoveredRange,
                DATE: recoverdedDate
            } : {}

        updateCampaignID(response.id)
        updateCampaignName(response.name)
        updateSelectedGroup(response.groups.map(each => ({ id: each.group, label: each.name })))

        // if (response.groups && response.groups.length > 0) {
        //     setContactType("filtered")
        //     setContactFilter("contact_group")
        // }
        if (response.contact_filters && response.contact_filters.length > 0) {
            setContactFilters(response.contact_filters)
            setContactFilter("")
            setContactFilterValue("")
        } else {
            setContactFilter(response.contact_filter)
            setContactFilterValue(response.contact_filter_value)
        }

        // E só depois disso:
        if (response.contact_filter === "contact_group" && response.groups?.length > 0) {
            setContactType("filtered")
            // setContactFilter("contact_group")  // já veio
        }

        if (response.contact_filter === "enterprises_contact_group" && response.groups?.length > 0) {
            setContactType("filtered")
            // setContactFilter("enterprises_contact_group") // já veio
            updateSelectedGroup(response.groups.map(each => ({ id: each.group, label: each.name })))
        }

        updateSelectedQueue(response.queue_name ? response.queue_name : '')
        updateSelectedSender(recoveredSender ? recoveredSender : '')
        updateSelectedTemplate(recoveredTemplate ? recoveredTemplate : '')
        setDeployParameters([])
        updateStep(response.step > 6 ? 6 : response.step)
        updateTimeSelector(recoveredPeriodic)
        setPlatform(response.platform)
        updateDateTimeSelector(recoveredDateTimeSelector)

        setContactType(response.contact_type)
        if (response.contact_type === "imported") {
            setSelectedFile({ name: response.contact_file })
            setAlreadyImported(true)
            if (response.id) {
                api.get(`/api/enterprises/${props.enterpriseId}/campaign/${response.id}/get_total_contacts/`)
                    .then(countResp => {
                        if (countResp && countResp.status === 200) {
                            setImportedFileCount(countResp.data)
                        }
                    })
                    .catch(() => {})
            }
        }
        if (response.contact_filters && response.contact_filters.length > 0) {
            setContactFilters(response.contact_filters)
            setContactFilter("")
            setContactFilterValue("")
        } else {
            setContactFilter(response.contact_filter)
            setContactFilterValue(response.contact_filter_value)
        }
        if (response.filters_combination) {
            setFiltersCombination(response.filters_combination)
        }
        if (response.phone_presence) {
            setPhonePresence(response.phone_presence)
        }
        setReportTrigger(response.report_trigger)
        setReportEmail(response.report_email)

        updateSelectedEnterprise(response.enterprises.map((each) => ({ id: each.contact_enterprise, label: each.name })))

        if (response.journey) {
            pendingJourneyColumnRef.current = response.journey_column_id ? String(response.journey_column_id) : null
            setState({ selectedJourney: String(response.journey) })
        }
        if (response.journey_column_id) {
            setState({ selectedColumn: String(response.journey_column_id) })
        }
        if (response.journey_tags && Array.isArray(response.journey_tags)) {
            setState({ tags: response.journey_tags })
        }
        if (response.journey_custom_fields && typeof response.journey_custom_fields === 'object') {
            setState({ selectedCustomFields: response.journey_custom_fields })
        }

        updateReady(true)
        if (response.year == '0' && response.step >= 3 && !response.periodic)
            updateSendNow(true)
    }

    const handleNumberChange = (number) => {
        if (getSession().profile.enterprise.abstraction_layer) {
            setNumberLoading(true)
            const enterpriseId = getSession().profile.enterprise.id
            const digits = number?.replace(/\D/g, '');
            if (!digits) return
            return api.get(`api/enterprises/${enterpriseId}/templates/${digits}/`)
                .then((res) => {
                    const templates = res.data.waba_templates.filter((t) => t.status.toLowerCase() === 'approved')
                    if (res.status === 200) {
                        setNumberLoading(false)
                        setNumberTemplates(templates)
                        updateSelectedSender(number)
                        setFilteredTemplates(templates)
                        return templates
                    }
                    throw err
                })
                .catch((err) => { setNumberLoading(false) })
        } else {
            setNumberLoading(false)
            updateSelectedSender(number);
            return props.templates
        }
    }

    const updateVoiceCampaignRow = (campaignId, data = {}) => {
        updateCampaigns(prevState => prevState.map(campaign => {
            if (String(campaign.id) !== String(campaignId))
                return campaign

            return {
                ...campaign,
                active: true,
                status: 'PROCESSING',
                voice_config: {
                    ...(campaign.voice_config || {}),
                    ads_state: data.ads_state || 'RUNNING',
                    ads_campaign_id: data.ads_campaign_id ?? campaign.voice_config?.ads_campaign_id,
                    ads_mailing_id: data.ads_mailing_id ?? campaign.voice_config?.ads_mailing_id,
                },
            }
        }))
    }

    useEffect(() => {
        const validation = changeData()
        updateCanNext(validation)
    }, [
        campaignName,
        selectedGroup,
        selectedQueue,
        selectedSender,
        selectedTemplate,
        actualStep,
        timeSelector,
        dateTimeSelector,
        sendNow,
        platform,
        smsState,
        emailState,
        scoutState,
        voiceState,
        contactType,
        contactFilter,
        contactFilterValue,
        reportTrigger,
        reportEmail,
        selectedEnterprise,
        selectedFile
    ])

    useEffect(() => {
        const fetchCountIfNeeded = () => {
            if (actualStep === 3 && contactType === 'imported' && importedFileCount == null && (campaignID || selectedFile)) {
                // if (campaignID) {
                //     api.get(`/api/enterprises/${props.enterpriseId}/campaign/${campaignID}/get_total_contacts/`)
                //         .then(countResp => {
                //             if (countResp && countResp.status === 200) {
                //                 setImportedFileCount(countResp.data)
                //             }
                //         })
                //         .catch(() => {
                            
                //         })
                //     return
                // }

                if (selectedFile && typeof selectedFile === 'object' && selectedFile.name) {
                    const file = selectedFile
                    const ext = file.name.split('.').pop().toLowerCase()
                    if (ext === 'csv') {
                        const reader = new FileReader()
                        reader.onload = function (e) {
                            const text = e?.target?.result
                            if (!text) return
                            const sep = detectSeparator(text)
                            const parsed = parseCSVToPreview(text, sep)
                            if (!parsed.error) {
                                const validCount = (parsed.rows || []).length - parsed.errors
                                setImportedFileCount(validCount)
                                setPreviewErrors(parsed.errors)
                            }
                        }
                        reader.readAsText(file)
                    }
                    if (ext === 'xlsx') {
                        const reader = new FileReader()
                        reader.onload = (e) => {
                            const data = e.target?.result
                            if (!data) return
                            const workbook = XLSX.read(data, { type: 'array' })
                            const sheetName = workbook.SheetNames[0]
                            const worksheet = workbook.Sheets[sheetName]
                            const rows = XLSX.utils.sheet_to_json(worksheet, {
                                header: 1,
                                blankrows: false,
                            })
                            const validCount = Math.max(rows.length - 1, 0)
                            setImportedFileCount(validCount)
                            setPreviewErrors(0)
                        }
                        reader.readAsArrayBuffer(file)
                    }
                }
            }
        }
        fetchCountIfNeeded()
    }, [actualStep, contactType, campaignID, selectedFile, importedFileCount])

    useEffect(() => {
        updateSendNow(false)
    }, [props.data])

    useEffect(() => {
        setForceEmailCcCco(false)
        if (props.selectedKey > 0 && props.open) {
            recoverCampaignData(props.selectedKey)
            updateReady(false)
            setCampaignCancelled(false)

            const fetchPendingNotifications = async () => {
                const response = await api.get(
                    `/api/enterprises/${props.enterpriseId}/campaign/${props.selectedKey}/pending_notifications/`
                )
                if (response.status === 200) {
                    setPendingNotifications(response.data)
                }
            }
            fetchPendingNotifications()
        } else {
            setPendingNotifications(null)
            setCampaignCancelled(false)
        }

        return (() => { })
    }, [props.open, props.selectedKey])


    const handleFilterChange = (event) => {
        let templates = props.templates
        if (getSession().profile.enterprise.abstraction_layer)
            templates = numberTemplates
        setFilteredTemplates(
            (templates.filter((template) => {
                const body = template.components?.find(each =>
                    each.type == 'BODY')?.text?.toLowerCase().includes(event.target.value.toLowerCase())
                const name = template.name?.toLowerCase().includes(event.target.value.toLowerCase())
                if (event.target.value && (body || name))
                    return true
                else if (event.target.value === "")
                    return true
            }))
        )
    }

    const downloadContactsTemplate = () => {
        
        window.open('/contact_list_example.csv', '_blank')
    }

    useEffect(() => {
        setFilteredTemplates(props.templates)
        //updateSelectedQueue(localStorage.getItem("last_template_queue"))
        if (!(props.selectedKey > 0))
            handleNumberChange(localStorage.getItem("last_template_number"))
    }, [])

    useEffect(() => {
        setContactFilterValue("")
    }, [contactFilter])

    const getFilterLabel = (filter) => {
        const labels = {
            'contact_group': 'Segmento',
            'contact_enterprise': 'Empresa',
            'contact_owner': 'Dono do contato',
            'email': 'Email termina com',
            'telephone': 'Telefone DDD',
            'created_gte': 'Criado a partir de',
            'created_lte': 'Criado até',
            'birthday': 'Aniversário mês',
            'has_phone': 'Com telefone',
            'no_phone': 'Sem telefone',
            'enterprises_contact_group': 'Empresas do segmento'
        }
        const fieldLabel = labels[filter.field] || filter.field
        if (filter.field === 'has_phone' || filter.field === 'no_phone') {
            return fieldLabel
        }
        if (filter.field === 'contact_owner') {
            if (filter.ownerLabels) {
                return `${fieldLabel}: ${filter.ownerLabels}`
            }
            return fieldLabel
        }
        if (filter.field === 'birthday') {
            return `${fieldLabel}: ${months[filter.value] || filter.value}`
        }
        return `${fieldLabel}: ${filter.value}`
    }

    const addFilterToList = (field, value, extraData = {}) => {
        if (isAddBlocked(field)) {
            useNotification(
                "Atenção",
                "O filtro 'Empresas que fazem parte do(s) segmento(s)' é exclusivo e não pode ser combinado com outros filtros.",
                "warning"
            );
            return;
        }
        const op = field === 'telephone' ? 'startswith' : 
                   field === 'email' ? 'endswith' : 
                   field === 'birthday' ? 'month' :
                   field === 'created_gte' ? 'gte' :
                   field === 'created_lte' ? 'lte' : 'exact'
        
        const newFilter = { field, op, value, ...extraData }
        setContactFilters(prev => [...prev, newFilter]);        
        setContactFilter("")
        setContactFilterValue("")
        updateSelectedGroup([])
        updateSelectedEnterprise([])
        updateSelectedOwner([])
        setOwnerInputValue("")
    }

    const clearCurrentFilter = () => {
        setContactFilter("")
        setContactFilterValue("")
        updateSelectedGroup([])
        updateSelectedEnterprise([])
        updateSelectedOwner([])
        setOwnerInputValue("")
    }

    useEffect(() => {
        if (hasExclusiveFilter && contactFilter && contactFilter !== EXCLUSIVE_FILTER) {
            clearCurrentFilter();
        }
        if (hasAnyOtherFilter && contactFilter === EXCLUSIVE_FILTER) {
            clearCurrentFilter();
        }
    }, [hasExclusiveFilter, hasAnyOtherFilter, contactFilter]);


    const getPendingFilter = () => {
        if (!contactFilter) return null
        
        if (contactFilter === 'has_phone' || contactFilter === 'no_phone') {
            return { field: contactFilter, op: 'exact', value: 'true' }
        }
        if (contactFilter === 'contact_group' && selectedGroup.length > 0) {
            return { 
                field: 'contact_group', 
                op: 'exact', 
                value: selectedGroup.map(g => g.label).join(', '),
                groupIds: selectedGroup.map(g => g.id)
            }
        }
        if (contactFilter === 'contact_enterprise' && selectedEnterprise.length > 0) {
            return { 
                field: 'contact_enterprise', 
                op: 'exact', 
                value: selectedEnterprise.map(e => e.label).join(', '),
                enterpriseIds: selectedEnterprise.map(e => e.id)
            }
        }
        if (contactFilter === 'contact_owner' && selectedOwner.length > 0) {
            return {
                field: 'contact_owner',
                op: 'exact',
                value: selectedOwner.map(o => o.id).join(','),
                ownerLabels: selectedOwner.map(o => o.label).join(', ')
            }
        }
        if (contactFilter === 'email' && contactFilterValue) {
            return { field: 'email', op: 'endswith', value: contactFilterValue }
        }
        if (contactFilter === 'telephone' && contactFilterValue) {
            return { field: 'telephone', op: 'startswith', value: contactFilterValue }
        }
        if (contactFilter === 'created_gte' && contactFilterValue) {
            return { field: 'created_gte', op: 'gte', value: contactFilterValue }
        }
        if (contactFilter === 'created_lte' && contactFilterValue) {
            return { field: 'created_lte', op: 'lte', value: contactFilterValue }
        }
        if (contactFilter === 'birthday' && contactFilterValue) {
            return { field: 'birthday', op: 'month', value: contactFilterValue }
        }
        if (contactFilter === 'enterprises_contact_group' && selectedGroup.length > 0) {
            return {
                field: 'enterprises_contact_group',
                op: 'exact',
                value: selectedGroup.map(g => g.label).join(', '),
                groupIds: selectedGroup.map(g => g.id)
            }
        }
        return null
    }

    const getAllFilters = () => {
        const pending = getPendingFilter()
        if (pending) {
            return [...contactFilters, pending]
        }
        return contactFilters
    }

    return (
        <>
            <div>
                <Loading loading={stepLoading} />
                {paramModal ?
                    <>
                      <ParamModal 
                        selectedTemplate={selectedTemplate}
                        parameters={parameters}
                        mediaParameters={mediaParameters}
                        checkParameters={checkParameters}
                        allParamsFilled={allParamsFilled}
                        updateParamModal={updateParamModal}
                        setUpdateButtons={setUpdateButtons}
                        handleParamGoBack={handleParamGoBack}
                      />  
                    </>
                    : null
                }
                {ready && props.open &&
                    <Dialog keepMounted
                        open={props.open}
                        onClose={props.handleClose}
                        aria-labelledby="customized-dialog-title"
                        fullWidth
                        className='multistepdialog'
                        disablePortal
                        disableEnforceFocus
                        sx={{ position: 'absolute' }}
                    >
                        <DialogTitle id="customized-dialog-title" className={'group-flexbox'}>
                            <span>{props.title}</span>
                            <Box>
                                <Button onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/como-realizar-campanhas-no-kwik-56nCEk0fBj", "_blank")}>FAQ</Button>
                                <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={() => { props.submit() }}>
                                    <CloseIcon />
                                </Button>
                            </Box>
                        </DialogTitle>
                        <Divider />
                        <DialogContent sx={{ overflow: "hidden", display: 'flex', flexDirection: 'column', gap: '1rem', overflow: "auto" }}>
                            {/* Banner de notificações pendentes ou canceladas */}
                            {campaignCancelled ? (
                                <Alert severity="success">
                                    <Typography>
                                        <strong>Campanha cancelada com sucesso!</strong> Os envios restantes foram cancelados.
                                    </Typography>
                                </Alert>
                            ) : pendingNotifications && pendingNotifications.pending > 0 && (
                                <Alert 
                                    severity="warning" 
                                    sx={{ 
                                        '& .MuiAlert-message': {
                                            width: '100%',
                                        }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                        <Typography>
                                            <strong>Campanha em andamento:</strong> {pendingNotifications.sent}/{pendingNotifications.total} enviados
                                        </Typography>
                                        <Button 
                                            variant="outlined" 
                                            color="warning" 
                                            size="small"
                                            onClick={() => {
                                                api.post(`/api/enterprises/${props.enterpriseId}/campaign/${props.selectedKey}/cancel_pending/`)
                                                    .then(response => {
                                                        if (response.status === 200) {
                                                            setCampaignCancelled(true)
                                                            useNotification(
                                                                "Sucesso",
                                                                `${response.data.cancelled} envios foram cancelados.`,
                                                                "success"
                                                            )
                                                        }
                                                    })
                                                    .catch(error => {
                                                        console.error('Erro ao cancelar envios:', error)
                                                        useNotification(
                                                            "Erro",
                                                            "Não foi possível cancelar os envios.",
                                                            "error"
                                                        )
                                                    })
                                            }}
                                        >
                                            Cancelar envios restantes
                                        </Button>
                                    </Box>
                                </Alert>
                            )}
                            <MultiStep
                                setTestCampaignModal={setTestCampaignModal}
                                onSubmit={submit} // which function to call after submit
                                setModalActions={setModalActions}
                                updateButtons={updateButtons}
                                canNext={canNext} // Is able to click next?
                                getStep={updateStep} // Store actual step
                                onNext={onNext} // Function to call when clicking next.
                                onOpen={actualStep}
                                canTestCampaign={platform !== 'VOICE'}
                                camp1={ // You can add multiple steps here with any name
                                    <>
                                        <Typography className="typography-title" variant="h6" gutterBottom>
                                            Identificação da campanha
                                        </Typography>
                                        <TextField
                                            size="small"
                                            label="Nome"
                                            fullWidth
                                            type="text"
                                            variant="outlined"
                                            value={campaignName}
                                            onChange={(event) => { updateCampaignName(event.target.value) }}
                                            inputProps={{
                                                maxLength: 50
                                            }}
                                        />
                                        <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                                            <InputLabel>Jornada (opcional)</InputLabel>
                                            <Select
                                                value={String(state.selectedJourney || "")}
                                                onChange={(e) => {
                                                    setState({ selectedJourney: e.target.value, editingCustomField: null, showNewCustomFieldForm: false })
                                                }}
                                                label="Jornada (opcional)"
                                            >
                                                <MenuItem value="">Nenhuma</MenuItem>
                                                {state.journeys.map((journey) => (
                                                    <MenuItem key={journey.id} value={String(journey.id)}>
                                                        {journey.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        
                                        {state.selectedJourney && (
                                            <>
                                                <Typography className="typography-title" variant="h6" gutterBottom sx={{ mt: 3 }}>
                                                    Configuração das Oportunidades
                                                </Typography>
                                                
                                                <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                                                    <InputLabel>Coluna da Jornada</InputLabel>
                                                    <Select
                                                        value={String(state.selectedColumn || "")}
                                                        onChange={(e) => {
                                                            setState({ selectedColumn: e.target.value })
                                                        }}
                                                        label="Coluna da Jornada"
                                                    >
                                                        {state.journeyColumns.map((column) => (
                                                            <MenuItem key={column.id} value={String(column.id)}>
                                                                {column.title}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                                <Box sx={{ mt: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                        <Typography variant="subtitle1">
                                                            Marcadores (opcional)
                                                        </Typography>
                                                        <IconButton
                                                            ref={newTagsRef}
                                                            onClick={() => setState({ tagsOpen: !state.tagsOpen })}
                                                            size="small"
                                                        >
                                                            <AddIcon />
                                                        </IconButton>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {state.tags.map((tagId) => {
                                                            const tag = state.allTags.find((t) => t.id === tagId);
                                                            if (!tag) return null;
                                                            return (
                                                                <Box
                                                                    key={tag.id}
                                                                    sx={{
                                                                        padding: ".25rem .5rem",
                                                                        borderRadius: ".25rem",
                                                                        fontSize: ".9em",
                                                                        backgroundColor: tag.color,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={() => setState({ tags: state.tags.filter(id => id !== tagId) })}
                                                                >
                                                                    {tag.name}
                                                                </Box>
                                                            );
                                                        })}
                                                    </Box>
                                                    <OpportunityMarkers 
                                                        tagsOpen={state.tagsOpen} 
                                                        setTagsOpen={(data)=>setState({tagsOpen: data})} 
                                                        allTags={state.allTags} 
                                                        newTagsRef={newTagsRef}
                                                        setParent={(changeParent) => {
                                                            setState(changeParent(state))
                                                        }} 
                                                        parent={state} 
                                                        selectedJourney={{id: state.selectedJourney}}
                                                    />
                                                </Box>

                                                <Box sx={{ mt: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                        <Typography variant="subtitle1">
                                                            Campos Personalizados (opcional)
                                                        </Typography>
                                                        <IconButton
                                                            ref={newCustomFieldsRef}
                                                            onClick={() => setState({ customFieldsOpen: !state.customFieldsOpen })}
                                                            size="small"
                                                        >
                                                            <AddIcon />
                                                        </IconButton>
                                                    </Box>
                                                    {state.customFields.length === 0 ? (
                                                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
                                                            Jornada sem campos personalizados.
                                                        </Typography>
                                                    ) : (
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                            {state.customFields.map((field) => (
                                                                <TextField
                                                                    key={field.id}
                                                                    size="small"
                                                                    label={field.name}
                                                                    fullWidth
                                                                    value={state.selectedCustomFields[field.id] || ''}
                                                                    onChange={(e) => setState({
                                                                        selectedCustomFields: {
                                                                            ...state.selectedCustomFields,
                                                                            [field.id]: e.target.value
                                                                        }
                                                                    })}
                                                                />
                                                            ))}
                                                        </Box>
                                                    )}
                                                </Box>

                                                <Popper
                                                    open={state.customFieldsOpen}
                                                    anchorEl={newCustomFieldsRef.current}
                                                    placement="bottom-start"
                                                    sx={{ zIndex: 9999 }}
                                                >
                                                    <ClickAwayListener onClickAway={() => {
                                                        if (state.selectOpen) return
                                                        setState({ customFieldsOpen: false })
                                                    }}>
                                                        <Paper sx={{ p: 2, minWidth: '300px', zIndex: 10000 }}>
                                                            {!state.showNewCustomFieldForm && (
                                                                <Box>
                                                                    {state.customFields.length === 0 && (
                                                                        <Box sx={{ mb: 2 }}>
                                                                            Jornada sem campos personalizados.
                                                                        </Box>
                                                                    )}
                                                                    {state.customFields.length > 0 && (
                                                                        <Box sx={{ mb: 2 }}>
                                                                            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                                                                                Campos existentes:
                                                                            </Typography>
                                                                                    {state.customFields.map((field) => (
                                                                                        <Box key={field.id} sx={{ padding: '0.25rem 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                                                                • {field.name} ({
                                                                                                    field.field_type === 'text' ? 'Texto' : field.field_type === 'textarea' ? 'Texto longo' : field.field_type === 'number' ? 'Número' : field.field_type === 'select' ? 'Lista' : field.field_type === 'date' ? 'Data' : field.field_type === 'checkbox' ? 'Checkbox' : field.field_type
                                                                                                }){field.required && ' - Obrigatório'}
                                                                                            </Typography>
                                                                                            <IconButton
                                                                                                size="small"
                                                                                                color="primary"
                                                                                                onClick={() => setState({ editingCustomField: field, showNewCustomFieldForm: true })}
                                                                                                sx={{ ml: 1 }}
                                                                                            >
                                                                                                <EditIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                            <IconButton
                                                                                                size="small"
                                                                                                color="error"
                                                                                                onClick={() => setState({ showDeleteCustomFieldConfirmation: field })}
                                                                                                sx={{ ml: 1 }}
                                                                                            >
                                                                                                <DeleteIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        </Box>
                                                                                    ))}
                                                                        </Box>
                                                                    )}
                                                                    <Button
                                                                        className="opportunity-btn"
                                                                        onClick={() => setState({ editingCustomField: null, showNewCustomFieldForm: true })}
                                                                        fullWidth
                                                                        size="small"
                                                                    >
                                                                        <AddIcon />
                                                                        Criar campo personalizado
                                                                    </Button>
                                                                </Box>
                                                            )}
                                                            {state.showNewCustomFieldForm && (
                                                                <NewCustomFieldForm
                                                                    initialField={state.editingCustomField}
                                                                    onBack={() => setState({ editingCustomField: null, showNewCustomFieldForm: false })}
                                                                    onSave={state.editingCustomField ? handleEditCustomField : handleSaveCustomField}
                                                                    onSelectOpenChange={(isOpen) => setState({ selectOpen: isOpen })}
                                                                />
                                                            )}
                                                        </Paper>
                                                    </ClickAwayListener>
                                                </Popper>
                                                {state.showDeleteCustomFieldConfirmation && (
                                                    <ConfirmationDialogCaptcha
                                                        open={state.showDeleteCustomFieldConfirmation}
                                                        title="Confirmação"
                                                        description={<Box>Para remover o campo personalizado "{state.showDeleteCustomFieldConfirmation.name}", digite: <span style={{ fontWeight: 'bold' }}>remover</span> no campo abaixo.</Box>}
                                                        handleClose={() => setState({ showDeleteCustomFieldConfirmation: null })}
                                                        handleSubmit={() => {
                                                            deleteCustomField(state.showDeleteCustomFieldConfirmation.id);
                                                            setState({ showDeleteCustomFieldConfirmation: null });
                                                        }}
                                                        captcha={"remover"}
                                                    />
                                                )}
                                            </>
                                        )}
                                        
                                        <Typography className="typography-title" variant="h6" gutterBottom sx={{ mt: 3 }}>
                                            Canal de envio
                                        </Typography>
                                        <Box className='campaign-decide-platform'>
                                            <Button variant={platform === 'WHATSAPP' ? 'contained' : 'standard'} onClick={() => setPlatform('WHATSAPP')}>Whatsapp</Button>
                                            <Button variant={platform === 'SMS' ? 'contained' : 'standard'} onClick={() => setPlatform('SMS')}>SMS</Button>
                                            <Button variant={platform === 'EMAIL' ? 'contained' : 'standard'} onClick={() => setPlatform('EMAIL')}>EMAIL</Button>
                                            {getSession().profile.enterprise.outbound_scout &&
                                                <Button variant={platform === 'SCOUT' ? 'contained' : 'standard'} onClick={() => setPlatform('SCOUT')}>SCOUT</Button>
                                            }
                                            <Button variant={platform === 'VOICE' ? 'contained' : 'standard'} onClick={() => setPlatform('VOICE')}>VOZ</Button>
                                        </Box>
                                    </>
                                }
                                camp2={
                                    <>
                                        {platform === 'WHATSAPP' && <>
                                            <WhatsappSelect
                                                selectedSender={selectedSender}
                                                handleNumberChange={handleNumberChange}
                                                senders={props.senders}
                                                filteredTemplates={filteredTemplates}
                                                selectedTemplate={selectedTemplate}
                                                handleSelectedTemplate={handleSelectedTemplate}
                                                mediaParameters={mediaParameters}
                                            />
                                        </>}
                                        {platform === 'SMS' && <>
                                            <Box sx={{ gap: '1rem', display: 'flex', flexDirection: 'column' }}>
                                                <SendSMSContent setLoading={setLoading} parent={smsState} setParent={setSmsState} queues={props.queues} />
                                            </Box>
                                        </>}
                                        {platform === 'EMAIL' && <>
                                            <Box sx={{ gap: '1rem', display: 'flex', flexDirection: 'column', padding: '.5rem', maxHeight: '23rem', overflow: 'auto' }}>
                                                <SendEmailContent
                                                    canCopy={true}
                                                    setLoading={() => { }}
                                                    parent={emailState}
                                                    setParent={setEmailState}
                                                    queues={props.queues}
                                                    emailMessageData={(data) => { emailState.emailMessageData = data }}
                                                    forceEmailCcCco={forceEmailCcCco}
                                                    setForceEmailCcCco={setForceEmailCcCco}
                                                    emailTemplates={emailTemplates}
                                                    selectedTemplate={selectedEmailTemplate}
                                                    onEmailTemplateChange={handleEmailTemplateChange}
                                                />
                                            </Box>
                                        </>}

                                        {platform === 'SCOUT' && <>
                                            <Box sx={{ gap: '1rem', display: 'flex', flexDirection: 'column', padding: '.5rem', maxHeight: '23rem', overflow: 'auto' }}>
                                                <SendScoutContent setLoading={() => { }} parent={scoutState} setParent={setScoutState} />
                                            </Box>
                                        </>}
                                        {platform === 'VOICE' && <>
                                            <VoiceCampaignConfig
                                                parent={voiceState}
                                                setParent={setVoiceState}
                                                destinations={voiceDestinations}
                                                queues={voiceQueues}
                                            />
                                        </>}
                                    </>
                                }
                                camp3={
                                    <>
                                        {platform === 'VOICE' ? (
                                            <VoiceCampaignConfig
                                                parent={voiceState}
                                                setParent={setVoiceState}
                                                destinations={voiceDestinations}
                                                queues={voiceQueues}
                                                advanced={true}
                                            />
                                        ) : (
                                            <>
                                                <Typography className="typography-title" variant="h6" gutterBottom>
                                                    Fila de atendimento que receberá a resposta do contato
                                                </Typography>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id="demo-simple-select-label">Fila</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Fila"
                                                        onChange={(event) => {
                                                            localStorage.setItem("last_template_queue", event.target.value)
                                                            updateSelectedQueue(event.target.value)
                                                        }}
                                                        value={selectedQueue}
                                                    >
                                                        <MenuItem value="">Sem fila</MenuItem>
                                                        {queues.map((queue) => (
                                                            <MenuItem key={queue[1]} value={queue[1]}>{queue[0]}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <Alert severity="info" className="template-alert-info">
                                                    Caso sua campanha seja informativa, e não necessite de atendimento, escolha a opção "Sem fila".
                                                </Alert>
                                            </>
                                        )}
                                    </>
                                }
                                camp4={
                                    <>
                                        {platform === 'VOICE' && voiceState.mode === 'CONTINUOUS'
                                            ? (
                                                <>
                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                        Entrada contínua
                                                    </Typography>
                                                    <Alert severity="info" className="template-alert-info">
                                                        Os contatos serão adicionados enquanto a campanha estiver ativa.
                                                    </Alert>
                                                </>
                                            )
                                            : props.selectedContacts && props.selectedContacts.length > 0
                                            ? (
                                                <>
                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                        Contatos que receberão a mensagem
                                                    </Typography>
                                                    {platform === "EMAIL" &&
                                                        <Alert severity="warning" className="template-alert-info">
                                                            <AlertTitle>Provedores de e-mail possuem limites diários de envio. </AlertTitle>
                                                            <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                                                <li>Gmail (conta pessoal): até aprox. <strong>500 envios/dia</strong></li>
                                                                <li>Gmail Workspace (corporativo): até aprox. <strong>2.000 envios/dia</strong></li>
                                                                <li>Outlook / Hotmail (gratuito): aprox. <strong>300 envios/dia</strong></li>
                                                                <li>Microsoft 365 / Exchange Online: até aprox. <strong>10.000 destinatários/dia</strong></li>
                                                            </ul>
                                                        </Alert>
                                                    }
                                                    <Alert severity="info" className="template-alert-info">
                                                        {props.selectedContacts.length} contactos selecionados da base de dados Kwik.
                                                    </Alert>
                                                </>
                                            )
                                            : (
                                                <>
                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                        Contatos que receberão a mensagem
                                                    </Typography>
                                                    {platform === "EMAIL" &&
                                                        <Alert severity="warning" className="template-alert-info">
                                                            <AlertTitle>Provedores de e-mail possuem limites diários de envio. </AlertTitle>
                                                            <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                                                <li>Gmail (conta pessoal): até aprox. <strong>500 envios/dia</strong></li>
                                                                <li>Gmail Workspace (corporativo): até aprox. <strong>2.000 envios/dia</strong></li>
                                                                <li>Outlook / Hotmail (gratuito): aprox. <strong>300 envios/dia</strong></li>
                                                                <li>Microsoft 365 / Exchange Online: até aprox. <strong>10.000 destinatários/dia</strong></li>
                                                            </ul>
                                                        </Alert>
                                                    }
                                                    <ButtonGroup className="button-group">
                                                        <Button className="button-group-child" variant={contactType === "filtered" ? "contained" : "outlined"} onClick={() => setContactType("filtered")}>Base de dados interna</Button>
                                                        <Button className="button-group-child" variant={contactType === "imported" ? "contained" : "outlined"} onClick={() => setContactType("imported")}>Importar contatos</Button>
                                                    </ButtonGroup>
                                                    {contactType === "filtered" &&
                                                        <>
                                                            {contactFilters.length > 0 && (
                                                                <Box sx={{ mb: 2 }}>
                                                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Filtros aplicados:</Typography>
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                                        {contactFilters.map((filter, index) => (
                                                                            <Chip 
                                                                                key={index}
                                                                                label={getFilterLabel(filter)}
                                                                                onDelete={() => setContactFilters(contactFilters.filter((_, i) => i !== index))}
                                                                                color="primary"
                                                                                variant="outlined"
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                </Box>
                                                            )}
                                                            
                                                            <FormControl fullWidth size="small">
                                                                <InputLabel>Adicionar filtro</InputLabel>
                                                                <Select 
                                                                    label="Adicionar filtro" 
                                                                    value={contactFilter}
                                                                    onChange={(event) => {
                                                                        setContactFilter(event.target.value)
                                                                        setContactFilterValue("")
                                                                    }}
                                                                    endAdornment={contactFilter && (
                                                                        <IconButton 
                                                                            size="small" 
                                                                            onClick={clearCurrentFilter}
                                                                            sx={{ mr: 2 }}
                                                                        >
                                                                            <CloseIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )}
                                                                >
                                                                    <MenuItem 
                                                                        value="contact_group" 
                                                                        disabled={isFilterOptionDisabled("contact_group")}
                                                                    >
                                                                            Que fazem parte do(s) segmento(s)
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="contact_enterprise"
                                                                        disabled={isFilterOptionDisabled("contact_enterprise")}
                                                                    >
                                                                        Que fazem parte da(s) empresa(s)
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="email" 
                                                                        disabled={isFilterOptionDisabled("email")}
                                                                    >
                                                                            Que possuam e-mail com final
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="telephone" 
                                                                        disabled={isFilterOptionDisabled("telephone")}
                                                                    >
                                                                            Que possuam telefone com DDD
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="created_gte"
                                                                        disabled={isFilterOptionDisabled("created_gte")}
                                                                    >
                                                                            Com data de criação maior, ou igual a
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="created_lte"
                                                                        disabled={isFilterOptionDisabled("created_lte")}
                                                                    >
                                                                            Com data de criação menor, ou igual a
                                                                    </MenuItem>
                                                                    <MenuItem value="contact_owner">Dono do contato</MenuItem>
                                                                    <MenuItem 
                                                                        value="birthday"
                                                                        disabled={isFilterOptionDisabled("birthday")}
                                                                    >
                                                                            Aniversariantes do mês
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="has_phone"
                                                                        disabled={isFilterOptionDisabled("has_phone")}
                                                                    >
                                                                            Apenas com telefone cadastrado
                                                                    </MenuItem>
                                                                    <MenuItem 
                                                                        value="no_phone"
                                                                        disabled={isFilterOptionDisabled("no_phone")}
                                                                    >
                                                                            Apenas sem telefone cadastrado
                                                                    </MenuItem>
                                                                    {platform === "EMAIL" && (
                                                                        <MenuItem 
                                                                            value={EXCLUSIVE_FILTER}
                                                                            disabled={isFilterOptionDisabled(EXCLUSIVE_FILTER)}
                                                                        >
                                                                            Empresas que fazem parte do(s) segmento(s)
                                                                        </MenuItem>
                                                                    )}

                                                                </Select>
                                                            </FormControl>
                                                            
                                                            {(contactFilter === "has_phone" || contactFilter === "no_phone") && (
                                                                <Button 
                                                                    variant="contained" 
                                                                    size="small"
                                                                    startIcon={<AddIcon />}
                                                                    disabled={isAddBlocked(contactFilter)}
                                                                    onClick={() => addFilterToList(contactFilter, 'true')}
                                                                    sx={{ mt: 1 }}
                                                                >
                                                                    Adicionar filtro
                                                                </Button>
                                                            )}
                                                            
                                                            {contactFilter === "contact_group" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha um ou mais segmentos abaixo
                                                                    </Typography>
                                                                    <Grid item lg={6} md={6} sm={6} xs={6} className="push-bottom">
                                                                        <FormControl fullWidth size="small">
                                                                            <Autocomplete
                                                                                labelId="multiple-autocomplete-label-label"
                                                                                id="multiple-autocomplete-label"
                                                                                size={'small'}
                                                                                multiple={true}
                                                                                options={clientGroup.map(
                                                                                    (option) => ({ id: option.id, label: option.name || option.label }))
                                                                                    .filter(
                                                                                        option => !selectedGroup.map(each => each.id).includes(option.id))
                                                                                }
                                                                                filterSelectedOptions
                                                                                value={selectedGroup}
                                                                                MenuProps={MenuProps}
                                                                                onChange={(event, newInputValue) => {
                                                                                    updateSelectedGroup(newInputValue);
                                                                                }}
                                                                                inputValue={inputValue}
                                                                                onInputChange={(e, v) => {
                                                                                    setInputValue(v)
                                                                                    delayedChange(v, 'group', updateclientGroupRows, setSmallLoading)
                                                                                }}
                                                                                noOptionsText="Nenhuma opção disponível"
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label='Segmentos'
                                                                                        slotProps={{
                                                                                            input: {
                                                                                                ...params.InputProps,
                                                                                                type: 'search',
                                                                                                endAdornment: (
                                                                                                    <>
                                                                                                        {smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                                        {params.InputProps.endAdornment}
                                                                                                    </>
                                                                                                ),
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                    {selectedGroup.length > 0 && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => {
                                                                                addFilterToList('contact_group', selectedGroup.map(g => g.label).join(', '), { groupIds: selectedGroup.map(g => g.id) })
                                                                            }}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "enterprises_contact_group" && platform === "EMAIL" && (
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha um ou mais segmentos abaixo (para buscar empresas desses segmentos)
                                                                    </Typography>

                                                                    <Grid item lg={6} md={6} sm={6} xs={6} className="push-bottom">
                                                                        <FormControl fullWidth size="small">
                                                                            <Autocomplete
                                                                                labelId="multiple-autocomplete-label-label"
                                                                                id="multiple-autocomplete-label-enterprises-contact-group"
                                                                                size="small"
                                                                                multiple
                                                                                options={clientGroup
                                                                                    .map((option) => ({ id: option.id, label: option.name || option.label }))
                                                                                    .filter(option => !selectedGroup.map(each => each.id).includes(option.id))
                                                                                }
                                                                                filterSelectedOptions
                                                                                value={selectedGroup}
                                                                                MenuProps={MenuProps}
                                                                                onChange={(event, newInputValue) => {
                                                                                    updateSelectedGroup(newInputValue);
                                                                                }}
                                                                                inputValue={inputValue}
                                                                                onInputChange={(e, v) => {
                                                                                    setInputValue(v)
                                                                                    delayedChange(v, 'group', updateclientGroupRows, setSmallLoading)
                                                                                }}
                                                                                noOptionsText="Nenhuma opção disponível"
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label="Segmentos"
                                                                                        slotProps={{
                                                                                            input: {
                                                                                                ...params.InputProps,
                                                                                                type: 'search',
                                                                                                endAdornment: (
                                                                                                    <>
                                                                                                        {smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                                        {params.InputProps.endAdornment}
                                                                                                    </>
                                                                                                ),
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>

                                                                    {selectedGroup.length > 0 && (
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={true} //Esse filtro é exclusivo para campanhas de email, e não pode ser combinado com outros filtros. Por isso, ele é sempre desabilitado
                                                                            onClick={() => {
                                                                                addFilterToList(
                                                                                    'enterprises_contact_group',
                                                                                    selectedGroup.map(g => g.label).join(', '),
                                                                                    { groupIds: selectedGroup.map(g => g.id) }
                                                                                )
                                                                            }}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            )}
                                                            {contactFilter === "contact_enterprise" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha uma ou mais empresas abaixo
                                                                    </Typography>
                                                                    <FormControl fullWidth size="small">
                                                                        <Autocomplete
                                                                            size="small"
                                                                            multiple={true}
                                                                            options={enterprises.map(
                                                                                (option) => ({ id: option.id, label: option.name || option.label }))
                                                                                .filter(
                                                                                    option => !selectedEnterprise.map(each => each.id).includes(option.id))
                                                                            }
                                                                            filterSelectedOptions
                                                                            value={selectedEnterprise}
                                                                            MenuProps={MenuProps}
                                                                            onChange={(event, newInputValue) => {
                                                                                updateSelectedEnterprise(newInputValue);
                                                                            }}
                                                                            inputValue={enterpriseInputValue}
                                                                            onInputChange={(e, v) => {
                                                                                setEnterpriseInputValue(v)
                                                                                delayedChange(v, "enterprise", updateEnterprises, setSmallLoading)
                                                                            }}
                                                                            noOptionsText="Nenhuma opção disponível"
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Empresas"
                                                                                    slotProps={{
                                                                                        input: {
                                                                                            ...params.InputProps,
                                                                                            type: "search",
                                                                                            endAdornment: (
                                                                                                <>
                                                                                                    {smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                                    {params.InputProps.endAdornment}
                                                                                                </>
                                                                                            ),
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </FormControl>
                                                                    {selectedEnterprise.length > 0 && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => {
                                                                                addFilterToList('contact_enterprise', selectedEnterprise.map(e => e.label).join(', '), { enterpriseIds: selectedEnterprise.map(e => e.id) })
                                                                            }}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "contact_owner" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha um ou mais donos do contato abaixo
                                                                    </Typography>
                                                                    <FormControl fullWidth size="small">
                                                                        <Autocomplete
                                                                            size="small"
                                                                            multiple={true}
                                                                            options={[{ id: 'public', label: 'Público' }, ...owners.map(
                                                                                (option) => ({ id: option.id, label: option.name || option.label }))]
                                                                                .filter(
                                                                                    option => !selectedOwner.map(each => each.id).includes(option.id))
                                                                            }
                                                                            filterSelectedOptions
                                                                            value={selectedOwner}
                                                                            MenuProps={MenuProps}
                                                                            onChange={(event, newInputValue) => {
                                                                                updateSelectedOwner(newInputValue)
                                                                            }}
                                                                            inputValue={ownerInputValue}
                                                                            onInputChange={(e, v) => {
                                                                                setOwnerInputValue(v)
                                                                                delayedChange(v, "user", updateOwners, setSmallLoading)
                                                                            }}
                                                                            noOptionsText="Nenhuma opção disponível"
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Donos do contato"
                                                                                    slotProps={{
                                                                                        input: {
                                                                                            ...params.InputProps,
                                                                                            type: "search",
                                                                                            endAdornment: (
                                                                                                <>
                                                                                                    {smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                                    {params.InputProps.endAdornment}
                                                                                                </>
                                                                                            ),
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </FormControl>
                                                                    {selectedOwner.length > 0 && (
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            onClick={() => {
                                                                                addFilterToList(
                                                                                    'contact_owner',
                                                                                    selectedOwner.map(o => o.id).join(','),
                                                                                    { ownerLabels: selectedOwner.map(o => o.label).join(', ') }
                                                                                )
                                                                            }}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "email" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Digite o final do e-mail abaixo (ex: instant.com.br)
                                                                    </Typography>
                                                                    <Box>
                                                                        <TextField
                                                                            size="small"
                                                                            label="Final do email"
                                                                            fullWidth
                                                                            type="text"
                                                                            variant="outlined"
                                                                            value={contactFilterValue}
                                                                            onChange={(event) => setContactFilterValue(event.target.value)}
                                                                        />
                                                                    </Box>
                                                                    {contactFilterValue && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => addFilterToList('email', contactFilterValue)}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "telephone" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Digite o DDD abaixo (ex: 21, para Rio de Janeiro)
                                                                    </Typography>
                                                                    <Box>
                                                                        <TextField
                                                                            size="small"
                                                                            label="DDD"
                                                                            fullWidth
                                                                            type="text"
                                                                            variant="outlined"
                                                                            value={contactFilterValue}
                                                                            onChange={(event) => {
                                                                                const value = event.target.value
                                                                                if (/^\d{0,2}$/.test(value))
                                                                                    setContactFilterValue(value)
                                                                            }}
                                                                            inputProps={{
                                                                                maxLength: 2,
                                                                                inputMode: "numeric",
                                                                                pattern: "[0-9]*"
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                    {contactFilterValue && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => addFilterToList('telephone', contactFilterValue)}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "created_gte" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha a data abaixo
                                                                    </Typography>
                                                                    <Box>
                                                                        <TextField
                                                                            size="small"
                                                                            label="Data"
                                                                            type="date"
                                                                            variant="outlined"
                                                                            value={contactFilterValue}
                                                                            onChange={(event) => setContactFilterValue(event.target.value)}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            fullWidth
                                                                        />
                                                                    </Box>
                                                                    {contactFilterValue && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => addFilterToList('created_gte', contactFilterValue)}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "created_lte" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha a data abaixo
                                                                    </Typography>
                                                                    <Box>
                                                                        <TextField
                                                                            size="small"
                                                                            label="Data"
                                                                            type="date"
                                                                            variant="outlined"
                                                                            value={contactFilterValue}
                                                                            onChange={(event) => setContactFilterValue(event.target.value)}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            fullWidth
                                                                        />
                                                                    </Box>
                                                                    {contactFilterValue && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => addFilterToList('created_lte', contactFilterValue)}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            {contactFilter === "birthday" &&
                                                                <>
                                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                                        Escolha o mês abaixo
                                                                    </Typography>
                                                                    <Box>
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel>Mês</InputLabel>
                                                                            <Select label="Mês" onChange={(event) => setContactFilterValue(event.target.value)} value={contactFilterValue}>
                                                                                {Object.entries(months).map(([key, value]) => (
                                                                                    <MenuItem key={key} value={key}>{value}</MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </Box>
                                                                    {contactFilterValue && (
                                                                        <Button 
                                                                            variant="contained" 
                                                                            size="small"
                                                                            startIcon={<AddIcon />}
                                                                            disabled={isAddBlocked(contactFilter)}
                                                                            onClick={() => addFilterToList('birthday', contactFilterValue)}
                                                                            sx={{ mt: 1 }}
                                                                        >
                                                                            Adicionar filtro
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                            
                                                            {contactFilters.some(f => f.field === 'no_phone') && (platform === "WHATSAPP" || platform === "SMS" || platform === "VOICE") && (
                                                                <Alert severity="warning" sx={{ mt: 1 }}>
                                                                    Atenção: campanhas de {platform === "VOICE" ? "Voz" : platform} requerem telefone. O filtro "Sem telefone" pode resultar em nenhum envio.
                                                                </Alert>
                                                            )}
                                                        </>
                                                    }
                                                    {contactType === "imported" &&
                                                        <>
                                                            <Alert severity="info" className="template-alert-info">
                                                                {platform === "WHATSAPP" && "Seu arquivo .csv ou .xlsx deve conter duas colunas: \"Nome\" e \"Telefone\"."}
                                                                {platform === "SMS" && "Seu arquivo .csv ou .xlsx deve conter duas colunas: \"Nome\" e \"Telefone\"."}
                                                                {platform === "VOICE" && "Seu arquivo .csv ou .xlsx deve conter duas colunas: \"Nome\" e \"Telefone\"."}
                                                                {platform === "EMAIL" && "Seu arquivo .csv ou .xlsx deve conter duas colunas: \"Nome\" e \"Email\"."}
                                                            </Alert>
                                                            <Box>
                                                                <Button
                                                                    size="small"
                                                                    variant="outlined"
                                                                    sx={{ mb: 1 }}
                                                                    onClick={() => {
                                                                        const files = [
                                                                          '/contact_list_simplified.csv',
                                                                          '/contact_list_simplified.xlsx',
                                                                        ];

                                                                        files.forEach((file) => {
                                                                            const a = document.createElement('a');
                                                                            a.href = file;
                                                                            a.download = '';
                                                                            document.body.appendChild(a);
                                                                            a.click();
                                                                            document.body.removeChild(a);
                                                                        });
                                                                    }}
                                                                >
                                                                    Baixar modelos de arquivo
                                                                </Button>

                                                                {importedFileCount != null && (
                                                                    <Box sx={{ mt: 0.5, mb: 1 }}>
                                                                        <Typography variant="body2">Quantidade de contatos: <strong>{importedFileCount} contatos</strong></Typography>
                                                                    </Box>
                                                                )}

                                                                <Box
                                                                    onDrop={(event) => {
                                                                        event.preventDefault()
                                                                        setDragOver(false)
                                                                        setSelectedFile(event.dataTransfer.files[0])
                                                                        setAlreadyImported(false)
                                                                    }}
                                                                    onDragOver={(event) => { event.preventDefault(); setDragOver(true) }}
                                                                    onDragLeave={() => setDragOver(false)}
                                                                    sx={{
                                                                        border: '2px dashed #aaa',
                                                                        padding: 4,
                                                                        textAlign: 'center',
                                                                        backgroundColor: dragOver ? '#f0f0f0' : '#fff',
                                                                        borderRadius: 1,
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() => fileInputRef.current.click()}
                                                                >
                                                                    {selectedFile && (
                                                                        <>
                                                                            <Typography variant="body1" sx={{ mb: 1 }}>
                                                                                Arquivo selecionado: <strong>{selectedFile.name}</strong>{importedFileCount != null ? ` — ${importedFileCount} contatos detectados` : ''}
                                                                            </Typography>
                                                                            {previewErrors != null && previewErrors > 0 && (
                                                                                <Typography variant="caption" color="error" sx={{ display: 'block' }}>{previewErrors} contatos com erros (não serão importados automaticamente)</Typography>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    <Typography variant="body1">
                                                                        Arraste e solte um arquivo .csv ou .xlsx aqui, ou clique para selecionar um arquivo.
                                                                    </Typography>
                                                                    <input
                                                                        ref={fileInputRef}
                                                                        type="file"
                                                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                                        style={{ display: "none" }}
                                                                        onChange={(event) => {
                                                                            const f = event.target.files[0]
                                                                            setSelectedFile(f)
                                                                            setAlreadyImported(false)
                                                                            handleCampaignFileSelect(f)
                                                                        }}
                                                                    />


                                                                </Box>
                                                            </Box>
                                                        </>
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                }
                                camp5={
                                    <>
                                        {platform === 'VOICE' && voiceState.mode === 'CONTINUOUS'
                                            ? (
                                                <>
                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                        Execução contínua
                                                    </Typography>
                                                    <Alert severity="info" className="template-alert-info">
                                                        A campanha ficará ativa até ser pausada ou encerrada.
                                                    </Alert>
                                                </>
                                            )
                                            : (
                                                <>
                                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                                        Periodicidade
                                                    </Typography>
                                                    <TimeSelector
                                                        state={timeSelector}
                                                        onChange={updateTimeSelector}
                                                        resetSelector={updateDateTimeSelector}
                                                        updateSendNow={updateSendNow}
                                                    />
                                                    <DateTimeSelector
                                                        time={timeSelector}
                                                        state={dateTimeSelector}
                                                        onChange={updateDateTimeSelector}
                                                        sendNow={sendNow}
                                                        updateSendNow={updateSendNow}
                                                        canNext={updateCanNext}
                                                    />
                                                </>
                                            )
                                        }
                                    </>
                                }
                                camp6={
                                    <>
                                        <Typography className="typography-title" variant="h6" gutterBottom>
                                            Defina quando quer receber o relatório de disparos (opcional)
                                        </Typography>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Período</InputLabel>
                                            <Select label="Período" onChange={(event) => setReportTrigger(event.target.value)} value={reportTrigger}>
                                                {Object.entries(reportTriggers).map(([key, value]) => (
                                                    <MenuItem value={key}>{value}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <Typography className="typography-title" variant="h6" gutterBottom>
                                            Digite abaixo o e-mail de quem receberá o relatório
                                        </Typography>
                                        <TextField
                                            size="small"
                                            label="E-mail"
                                            type="email"
                                            variant="outlined"
                                            defaultValue={reportEmail}
                                            onChange={(event) => setReportEmail(event.target.value)}
                                            fullWidth
                                        />
                                    </>
                                }
                                camp7={
                                    <>
                                        <Typography className="typography-title" variant="h6" gutterBottom>
                                            Resumo da campanha
                                        </Typography>
                                        <CampaignSummary
                                            name={campaignName}
                                            groups={clientGroup}
                                            groupkey={selectedGroup}
                                            queues={queues}
                                            queue={selectedQueue}
                                            sender={selectedSender}
                                            template={selectedTemplate}
                                            time={timeSelector}
                                            datetime={dateTimeSelector}
                                            sendNow={sendNow}
                                            platform={platform}
                                            state={platform === 'SMS' ? smsState : platform === 'EMAIL' ? emailState : platform === 'SCOUT' ? scoutState : null}
                                            mediaParameters={mediaParameters}
                                            onSubmit={submit}
                                            setTestCampaignModal={setTestCampaignModal}
                                            testCampaignModal={testCampaignModal}
                                            setTestCampaignNumber={setTestCampaignNumber}
                                            testCampaignNumber={testCampaignNumber}
                                            selectedContacts={props.selectedContacts}
                                            contactType={contactType}
                                            contactFilter={contactFilter}
                                            contactFilterValue={contactFilterValue}
                                            enterprises={enterprises}
                                            selectedEnterprise={selectedEnterprise}
                                            reportTrigger={reportTrigger}
                                            reportEmail={reportEmail}
                                            campaignId={campaignID}
                                            selectedFile={selectedFile}
                                            importedFileCount={importedFileCount}
                                            voiceConfig={voiceState}
                                        />
                                    </>
                                }
                            />
                        </DialogContent>
                        {modalActions}
                    </Dialog>
                }
            </div>
        </>
    )
}

export default CreateCampaignModal
